/* ============================================================
   TARRMU — migrated from Settings -> Code injection (Site Footer)
   Loaded via {{asset "built/tarrmu.js"}} in default.hbs, blocking,
   at end of <body> before {{ghost_foot}} — so window.Tarrmu /
   TarrmuAuth / TarrmuXP are defined before any page-level footer
   injection runs. Order below is load-bearing: core -> auth ->
   features. Each block self-guards, so it is harmless if the old
   Site Footer injection is still present during rollover.
   Not minified on purpose: this theme is uploaded via the admin
   GUI with no build step, so it must stay hand-editable.
   ============================================================ */

/* ---------- TARRMU CORE ---------- */
(function(){'use strict';
  if(window.Tarrmu) return;

  var SB_URL='https://atbxgcbghwddgvfzodfz.supabase.co';
  var SB_ANON='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0YnhnY2JnaHdkZGd2ZnpvZGZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUzMTI5MDgsImV4cCI6MjA5MDg4ODkwOH0.pSPOL8PbfWJ4kSyN9ZViUM6-WBvM10a0FfB88tmSC0E';

  function authToken(){
    try{
      var A=window.TarrmuAuth;
      if(A&&typeof A._readCache==='function'){
        var c=A._readCache();
        if(c&&c.token) return c.token;
      }
    }catch(e){}
    return null;
  }

  function bearer(){ return 'Bearer '+(authToken()||SB_ANON); }

  function handle(label){
    return function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error(label+' '+r.status+' '+t); });
      if(r.status === 204) return null;
      return r.json();
    };
  }

  window.Tarrmu={
    SB_URL:SB_URL,
    SB_ANON:SB_ANON,
    token:authToken,

    esc:function(s){
      return String(s==null?'':s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    },
    safeUrl:function(u){ return (typeof u==='string'&&/^https?:\/\//i.test(u))?u:''; },
    /* Avatar thumbnail helper. Supabase /object/public ignores ?width= and
       serves the ORIGINAL upload (some are 700KB+ for a 28-44px avatar);
       only the /render/image/ transform endpoint resizes. Rewrite the path
       so ?width= takes effect — 160px is 3-5x the avatar display size, so
       it stays sharp on retina while dropping a multi-hundred-KB download
       to a few KB. Non-Supabase URLs pass through untouched. */
    av:function(u,w){
      var s=this.safeUrl(u); if(!s) return '';
      if(/\/storage\/v1\/object\/public\//.test(s)){
        s=s.replace('/storage/v1/object/public/','/storage/v1/render/image/public/');
        var n=w||160;
        return s+(s.indexOf('?')===-1?'?':'&')+'width='+n+'&height='+n+'&resize=cover';
      }
      return s;
    },
    initial:function(n){ n=(n||'?').trim(); return n?n.charAt(0).toUpperCase():'?'; },
    initials:function(n){
      var p=(n||'').trim().split(/\s+/).filter(Boolean);
      if(!p.length) return '?';
      if(p.length===1) return p[0].slice(0,2).toUpperCase();
      return (p[0][0]+p[p.length-1][0]).toUpperCase();
    },

    rpc:function(fn,body,signal){
      return fetch(SB_URL+'/rest/v1/rpc/'+fn,{
        method:'POST',
        headers:{
          'apikey':SB_ANON,
          'Authorization':bearer(),
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify(body||{}),
        signal:signal
      }).then(handle('rpc '+fn));
    },
    rest:function(path,signal){
      /* 4_1_124 perf: pass the anon key as a QUERY param and send no custom
         headers on GETs. A custom `apikey` header (even an empty Authorization)
         makes the browser fire a CORS preflight (OPTIONS) before every GET —
         ~0.5-1s each, and the real request waits for it. With the key in the
         URL and only Accept set, the GET is a simple request: no preflight.
         The anon key is public by design (it already sits in this file and in
         page URLs); behaviour is identical, only the transport is lighter.
         Member calls still attach Authorization only when a token exists. */
      var sep = path.indexOf('?') === -1 ? '?' : '&';
      var url = SB_URL + '/rest/v1/' + path + sep + 'apikey=' + encodeURIComponent(SB_ANON);
      var h = { 'Accept': 'application/json' };
      var t = authToken();   /* real member JWT only — the anon key already rides in the URL */
      if (t) h['Authorization'] = 'Bearer ' + t;
      return fetch(url, { headers: h, signal: signal }).then(handle('rest ' + path));
    },

    timeAgo:function(iso){
      var d=new Date(iso), s=Math.max(0,(Date.now()-d.getTime())/1000);
      if(s<60) return 'just now';
      if(s<3600) return Math.floor(s/60)+'m ago';
      if(s<86400) return Math.floor(s/3600)+'h ago';
      if(s<604800) return Math.floor(s/86400)+'d ago';
      return d.toLocaleDateString();
    },
    fmtDate:function(d){
      if(!d) return '';
      var dt=new Date(d); if(isNaN(dt)) return '';
      var day=dt.getDate();
      var suf=(day%10===1&&day!==11)?'st':(day%10===2&&day!==12)?'nd':(day%10===3&&day!==13)?'rd':'th';
      return dt.toLocaleString('en-AU',{month:'long'})+' '+day+suf+' '+dt.getFullYear();
    },
    onReady:function(fn){
      if(document.readyState!=='loading') fn();
      else document.addEventListener('DOMContentLoaded',fn);
    },
    whenAuthReady:function(timeoutMs){
      return new Promise(function(res){
        if(window.TarrmuAuth&&window.TarrmuAuth.ready){ res(true); return; }
        var done=false;
        function fin(){ if(done)return; done=true; res(!!(window.TarrmuAuth&&window.TarrmuAuth.ready)); }
        window.addEventListener('tarrmu-auth-ready',fin,{once:true});
        if(timeoutMs) setTimeout(fin,timeoutMs);
      });
    }
  };

  window.Tarrmu.anonRpc=function(fn,body,signal){
    return fetch(SB_URL+'/rest/v1/rpc/'+fn,{
      method:'POST',
      headers:{
        'apikey':SB_ANON,
        'Authorization':'Bearer '+SB_ANON,
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify(body||{}),
      signal:signal
    }).then(handle('rpc '+fn));
  };

  /* Canonical XP ladder -- single source of truth for the whole site.
     Banded curve: each level inside a band costs a fixed amount, stepping
     up at every band boundary. Entry = [anchorLevel, xpPerLevelInBand, rank];
     the rate applies to each level gained FROM this anchor to the next.
     Verified totals: L5=400  L50=15,150  L100=66,650  L2000=37,604,150. */
  var BANDS=[
    [1,100,'LURKER'],[5,150,'COMMENTER'],[10,200,'REGULAR'],[20,300,'CONTRIBUTOR'],
    [30,400,'CRITIC'],[40,500,'EXPERT'],[50,650,'TASTEMAKER'],[60,800,'CONNOISSEUR'],
    [70,1000,'ELITE'],[80,1200,'CHAMPION'],[90,1500,'SPECIALIST'],[100,2000,'LEGEND'],
    [125,2500,'MYTHIC'],[150,3000,'PARAGON'],[175,4000,'ORACLE'],[200,5000,'ASCENDANT'],
    [500,8000,'IMMORTAL'],[750,12000,'CELESTIAL'],[1000,18000,'TRANSCENDENT'],
    [1250,25000,'ETERNAL'],[1500,40000,'ZENITH'],[2000,40000,'APEX']
  ];
  /* cumulative XP to REACH each anchor level, computed once */
  var XPCUM=[0];
  for(var _b=1;_b<BANDS.length;_b++){
    XPCUM[_b]=XPCUM[_b-1]+(BANDS[_b][0]-BANDS[_b-1][0])*BANDS[_b-1][1];
  }
  function _bandIdxLvl(L){ var idx=0; for(var i=0;i<BANDS.length;i++){ if(L>=BANDS[i][0]) idx=i; else break; } return idx; }
  function _xpForLevel(L){
    L=Math.floor(Number(L)||0);
    if(L<=1) return 0;
    var idx=_bandIdxLvl(L);
    return XPCUM[idx]+(L-BANDS[idx][0])*BANDS[idx][1];
  }
  function _levelFromXp(xp){
    xp=Math.max(0,Math.floor(Number(xp)||0));
    var idx=0;
    for(var i=0;i<BANDS.length;i++){ if(xp>=XPCUM[i]) idx=i; else break; }
    return BANDS[idx][0]+Math.floor((xp-XPCUM[idx])/BANDS[idx][1]);
  }
  /* 4_1_311 gaming member ranks (thread: Gaming-themed member rank names). 125 names Lv 1 -> 10,000.
     XP cost per level is unchanged: BANDS above still drives the XP maths (its [2] names are legacy).
     Source: member-ranks/rank-names-final.json + rank-colors-v6/v8 styles. */
  var RANK_LIST=[[1,"HATCHLING"],[2,"SLIME"],[3,"NINJA DOG"],[4,"JIMBO"],[5,"CHINPIRA"],[6,"PEON"],[7,"SPLICER"],[8,"RAIDER"],[9,"BANDICOOT"],[10,"ROOKIE COP"],[11,"SHIP ENGINEER"],[12,"TADPOLED"],[13,"PORTER"],[14,"VAULT DWELLER"],[15,"OUTLAW"],[16,"NYPD DETECTIVE"],[17,"DEPUTY"],[18,"NOVICE ASSASSIN"],[19,"ARWING PILOT"],[20,"TARNISHED"],[22,"RANGER"],[24,"STRANDED"],[26,"VAULT HUNTER"],[28,"THE KNIGHT"],[30,"EXPEDITIONER"],[32,"NEON"],[34,"CHOSEN UNDEAD"],[36,"PURPLE DRAGON"],[38,"PERSONA USER"],[40,"YORHA ANDROID"],[42,"MASTER OF UNLOCKING"],[44,"THRONE CANDIDATE"],[46,"DEMON SUMMONER"],[48,"LOMBAX"],[50,"GOOD HUNTER"],[52,"TACTICIAN"],[54,"BOUNTY HUNTER"],[56,"STAR WARRIOR"],[58,"WITCHER"],[60,"GUNSLINGER"],[62,"BLUE BOMBER"],[64,"COG GEAR"],[66,"HOLY KNIGHT"],[68,"PHANTOM THIEF"],[70,"SHAOLIN MONK"],[72,"DEVIL HUNTER"],[74,"DRAGONBORN"],[76,"WORLD WARRIOR"],[78,"GALACTIC RANGER"],[80,"SUMMONER"],[82,"OVERWATCH AGENT"],[84,"LUMINARY"],[86,"ROYAL PROTECTOR"],[88,"MONADO WIELDER"],[90,"HERO OF ALBION"],[92,"SPECTRE"],[94,"ELITE LICENSE"],[96,"MASTER ASSASSIN"],[98,"FIVE STARS"],[100,"HERO OF TIME"],[110,"SOLDIER 1ST CLASS"],[125,"DELTA SQUAD"],[140,"MAD DOG OF SHIMANO"],[150,"CHAMPION OF HYRULE"],[175,"BIG DADDY"],[200,"WILD CARD"],[225,"ERDRICK"],[250,"WHITE WOLF"],[275,"PRINCE OF THE UNDERWORLD"],[300,"MASTER NINJA"],[325,"BUREAU DIRECTOR"],[350,"CHOZO WARRIOR"],[375,"BLACKLIST #1"],[400,"BHAALSPAWN"],[450,"SON OF SPARDA"],[475,"GUARDIAN GENERAL"],[500,"MASTER CHIEF"],[550,"PURE VESSEL"],[600,"WARRIOR OF LIGHT"],[650,"NAHOBINO"],[700,"NEMESIS"],[750,"CHALLENGER"],[800,"ELDEN LORD"],[850,"STRIKE COMMANDER"],[900,"DOOM SLAYER"],[950,"SOLID SNAKE"],[1000,"DRAGON OF DOJIMA"],[1100,"HERALD OF DARKNESS"],[1250,"PAINTRESS"],[1400,"GRIM REAPER"],[1500,"LEGENDARY DARK KNIGHT"],[1600,"MENTOR"],[1750,"KINGSLAYER"],[2000,"TRIFORCE BEARER"],[2250,"MASTER OF THE FIST"],[2500,"EYE OF THE UNIVERSE"],[2750,"LEGEND OF LEGENDS"],[3000,"BUTCHER OF BLAVIKEN"],[3250,"DRAGON NINJA"],[3500,"LEGEND OF THE EAST"],[3750,"DRAGONLORD"],[4000,"LOCUST QUEEN"],[4250,"MOTHER BRAIN"],[4500,"DEMON KING"],[4750,"THE ABSOLUTE"],[5000,"QUEEN OF BLADES"],[5500,"DEMI-FIEND"],[5750,"THE OUTSIDER"],[6000,"DEMIGOD OF WRATH"],[6250,"JACK OF BLADES"],[6500,"ELDER GOD"],[6750,"THE RADIANCE"],[7000,"LICH KING"],[7250,"FELL DRAGON"],[7500,"ONE-WINGED ANGEL"],[7750,"REAPER"],[8000,"TRICKSTER"],[8250,"GRAVEMIND"],[8500,"OUROBOROS"],[8750,"EXTINCTION ENTITY"],[9000,"THAT MAN"],[9250,"LORD OF THE DEAD"],[9500,"ICON OF SIN"],[9750,"THE CHOSEN ONE"],[10000,"BIG BOSS"]];
  /* [fromLevel, classes, css vars] - colour steps; only Phoenix, Halo + Big Boss animate */
  var RANK_STYLES=[[1,"ol","--e:#4a5060;--tt:#8a91a3;--tb:transparent;--lb:#4a5060;--lt:#f2f2f7"],[5,"ol","--e:#6a5f80;--tt:#a99cc4;--tb:transparent;--lb:#6a5f80;--lt:#f2f2f7"],[10,"ol","--e:#56708f;--tt:#93abc9;--tb:transparent;--lb:#56708f;--lt:#f2f2f7"],[15,"ol","--e:#5f7a4a;--tt:#a3c28a;--tb:transparent;--lb:#5f7a4a;--lt:#f2f2f7"],[20,"tint","--e:#9a6a42;--tt:#d29a6c;--tb:rgba(154,106,66,.13);--lb:#9a6a42;--lt:#ffffff"],[28,"tint","--e:#b0852e;--tt:#e2bd6e;--tb:rgba(176,133,46,.13);--lb:#b0852e;--lt:#ffffff"],[36,"tint","--e:#b8653a;--tt:#ec9a6e;--tb:rgba(184,101,58,.13);--lb:#b8653a;--lt:#ffffff"],[44,"tint","--e:#c4545a;--tt:#f19297;--tb:rgba(196,84,90,.13);--lb:#c4545a;--lt:#ffffff"],[50,"tint","--e:#3fa36b;--tt:#7fd8a3;--tb:rgba(63,163,107,.13);--lb:#2f8a57;--lt:#ffffff"],[58,"tint","--e:#8bb33a;--tt:#c3e57a;--tb:rgba(139,179,58,.13);--lb:#6d9226;--lt:#ffffff"],[66,"tint","--e:#3fb8b0;--tt:#7ae0d8;--tb:rgba(63,184,176,.13);--lb:#2f9a93;--lt:#ffffff"],[76,"tint","--e:#3aa6d8;--tt:#86d2f5;--tb:rgba(58,166,216,.13);--lb:#2a8ab8;--lt:#ffffff"],[84,"g7 tint","--e:#4a86e0;--tt:#9cc2ff;--tb:rgba(74,134,224,.13);--lb:#4a86e0;--lt:#ffffff"],[92,"g7 tint","--e:#7a6ae6;--tt:#bcb2ff;--tb:rgba(122,106,230,.13);--lb:#7a6ae6;--lt:#ffffff"],[110,"","--e:#c9cfdc;--tt:#1d2230;--tb:linear-gradient(180deg,#f2f4f8,#b9c0cf);--lb:#6b7385;--lt:#ffffff"],[200,"g9","--e:#e8a79a;--tt:#3a1712;--tb:linear-gradient(180deg,#ffd9cf,#d98c7c);--lb:#7a3d33;--lt:#ffe3dc"],[300,"g9","--e:#e6b43c;--tt:#2a1d05;--tb:linear-gradient(180deg,#ffe29a,#d9a233);--lb:#7a5510;--lt:#ffe7a8"],[500,"g","--e:#ff6b86;--tt:#fff;--tb:linear-gradient(180deg,#d8344f,#8e1530);--lb:#4e0a18;--lt:#ffb3c1;--gl:rgba(216,52,79,.35)"],[550,"g","--e:#4fe39a;--tt:#fff;--tb:linear-gradient(180deg,#1fa86a,#0b5c38);--lb:#06331f;--lt:#a8ffd3;--gl:rgba(40,200,120,.35)"],[600,"g","--e:#5fa8ff;--tt:#fff;--tb:linear-gradient(180deg,#2f6fe0,#163a8e);--lb:#0b1d4e;--lt:#b8d6ff;--gl:rgba(60,130,255,.38)"],[650,"g","--e:#c792ff;--tt:#fff;--tb:linear-gradient(100deg,#5b2bbf,#9a33b8);--lb:#2c1260;--lt:#dcc2ff;--gl:rgba(160,80,255,.38)"],[700,"g","--e:#3fe0e8;--tt:#dffcff;--tb:linear-gradient(180deg,#0c3a4a,#06202b);--lb:#0a6f7a;--lt:#e6feff;--gl:rgba(50,220,235,.4)"],[750,"g","--e:#ff4a5e;--tt:#ffd0d5;--tb:linear-gradient(180deg,#2a0610,#140208);--lb:#9c1328;--lt:#ffe0e4;--gl:rgba(255,60,80,.38)"],[800,"ember","--e:#ff7a3a;--tt:#ffd9bf;--tb:#1f100c;--lb:linear-gradient(180deg,#ff5a2e,#c4361b);--lt:#fff2e8"],[850,"frost","--tt:#0d2233;--tb:#eaf7ff;--lb:#123a55;--lt:#e6f6ff"],[900,"aurora","--tt:#e8fff6;--tb:#101a24;--lb:#163240;--lt:#d6fff0"],[950,"prism","--e:#b9b0f6;--tt:#eef0ff;--tb:#17172b;--lb:#2a2a4a;--lt:#e8e4ff"],[1000,"vx","--a:#8a4dff;--z:#2ee6ff;--tt:#decdff;--tb:#110c1c;--lb:#2f1b56;--lt:#caafff;--gl:rgba(138,77,255,.35)"],[1500,"vx","--a:#ff4fb8;--z:#ff9a3d;--tt:#ffceeb;--tb:#110c1c;--lb:#4f1c42;--lt:#ffb0df;--gl:rgba(255,79,184,.35)"],[2000,"vx","--a:#ffcc4d;--z:#e0263f;--tt:#fff1cd;--tb:#110c1c;--lb:#4f3f24;--lt:#ffe8af;--gl:rgba(255,204,77,.35)"],[2500,"vx","--a:#b6ff3d;--z:#19c9a0;--tt:#ebffc9;--tb:#110c1c;--lb:#3b4d1f;--lt:#deffa8;--gl:rgba(182,255,61,.35)"],[3000,"vx","--a:#3dd8ff;--z:#ff5fd2;--tt:#c9f4ff;--tb:#110c1c;--lb:#194256;--lt:#a8edff;--gl:rgba(61,216,255,.35)"],[3500,"vx","--a:#2e7bff;--z:#3dffd0;--tt:#c4daff;--tb:#110c1c;--lb:#152856;--lt:#a1c4ff;--gl:rgba(46,123,255,.35)"],[4000,"vx","--a:#ff3d2e;--z:#ffd23d;--tt:#ffc9c4;--tb:#110c1c;--lb:#4f171b;--lt:#ffa8a1;--gl:rgba(255,61,46,.35)"],[4500,"vx","--a:#d36bff;--z:#ff6b9a;--tt:#f3d6ff;--tb:#110c1c;--lb:#432456;--lt:#ebbcff;--gl:rgba(211,107,255,.35)"],[5000,"vx","--a:#e6f7ff;--z:#5fb8ff;--tt:#f8fdff;--tb:#110c1c;--lb:#484b56;--lt:#f4fbff;--gl:rgba(230,247,255,.35)"],[5500,"vx","--a:#d4ff3d;--z:#9a3dff;--tt:#f3ffc9;--tb:#110c1c;--lb:#434d1f;--lt:#ecffa8;--gl:rgba(212,255,61,.35)"],[6000,"vx","--a:#ff7a3d;--z:#b03dff;--tt:#ffdac9;--tb:#110c1c;--lb:#4f281f;--lt:#ffc3a8;--gl:rgba(255,122,61,.35)"],[6500,"vx","--a:#3dff8a;--z:#ffd23d;--tt:#c9ffde;--tb:#110c1c;--lb:#194d35;--lt:#a8ffca;--gl:rgba(61,255,138,.35)"],[7000,"vx","--a:#ffc2dc;--z:#fff3a6;--tt:#ffeef5;--tb:#110c1c;--lb:#4f3c4c;--lt:#ffe4ef;--gl:rgba(255,194,220,.35)"],[7500,"vx","--a:#ffe23d;--z:#3d8aff;--tt:#fff7c9;--tb:#110c1c;--lb:#4f451f;--lt:#fff2a8;--gl:rgba(255,226,61,.35)"],[8000,"vx","--a:#ff2e4a;--z:#ff9aa8;--tt:#ffc4cc;--tb:#110c1c;--lb:#4f1323;--lt:#ffa1ae;--gl:rgba(255,46,74,.35)"],[8500,"vx","--a:#00e0ff;--z:#0a3dff;--tt:#b8f6ff;--tb:#110c1c;--lb:#084456;--lt:#8cf1ff;--gl:rgba(0,224,255,.35)"],[9000,"vx mv","--a:#ff4a1e;--z:#ffe9a6;--tt:#ffccc0;--tb:#110c1c;--lb:#4f1a17;--lt:#ffae9a;--gl:rgba(255,74,30,.35)"],[9500,"vx mv","--a:#ffffff;--z:#ffd36b;--tt:#ffffff;--tb:#110c1c;--lb:#4f4d56;--lt:#ffffff;--gl:rgba(255,255,255,.35)"],[10000,"boss","--e:#e6b43c;--tt:#ffd76a;--tb:linear-gradient(180deg,#1a1408,#000);--lb:linear-gradient(180deg,#ffe29a,#d9a233);--lt:#1a1206"]];
  function _pick(list,L){ L=Math.max(1,Math.floor(Number(L)||1)); var r=list[0]; for(var i=1;i<list.length;i++){ if(L>=list[i][0]) r=list[i]; else break; } return r; }
  function _rankFromLevel(L){ return _pick(RANK_LIST,L)[1]; }
  function _escR(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  /* | LV 235 | ERDRICK |  - opts.size:'lg' for profile hero; opts.block wraps it on its own line */
  function _rankBadge(L,opts){
    opts=opts||{}; L=Math.max(1,Math.floor(Number(L)||1));
    var s=_pick(RANK_STYLES,L), name=_rankFromLevel(L), boss=/\bboss\b/.test(s[1]);
    var lv=L>999?L.toLocaleString('en-US'):String(L);
    var h='<span class="trk '+s[1]+(opts.size?' trk-'+opts.size:'')+'" style="'+s[2]+'" title="Level '+lv+' \u00b7 '+_escR(name)+'">'+
          '<span class="lv">LV '+lv+'</span><span class="ti">'+(boss?'<b>\u2605</b>':'')+_escR(name)+'</span></span>';
    return opts.block?'<span class="trk-line">'+h+'</span>':h;
  }
  var RANKS=RANK_LIST; /* back-compat [level,name] pairs */
  window.TarrmuXP={
    BANDS:BANDS,
    RANKS:RANKS,
    xpForLevel:_xpForLevel,
    levelFromXp:_levelFromXp,
    rankFromLevel:_rankFromLevel,
    rankFromXp:function(xp){ return _rankFromLevel(_levelFromXp(xp)); },
    RANK_STYLES:RANK_STYLES,
    rankBadge:_rankBadge,
    rankBadgeFromXp:function(xp,opts){ return _rankBadge(_levelFromXp(xp),opts); },
    xpIntoLevel:function(xp){ xp=Math.max(0,Math.floor(Number(xp)||0)); return xp-_xpForLevel(_levelFromXp(xp)); },
    /* everything an XP bar needs for the banded curve */
    levelProgress:function(xp){
      xp=Math.max(0,Math.floor(Number(xp)||0));
      var level=_levelFromXp(xp), floorXp=_xpForLevel(level), nextXp=_xpForLevel(level+1);
      var into=xp-floorXp, span=nextXp-floorXp;
      return { xp:xp, level:level, rank:_rankFromLevel(level), into:into, span:span,
               pct: span>0 ? Math.max(0,Math.min(100,Math.round(into/span*100))) : 100,
               toNext: Math.max(0,span-into), floorXp:floorXp, nextXp:nextXp };
    }
  };

  var btn=document.getElementById('back-to-top');
  if(btn){
    window.addEventListener('scroll',function(){
      btn.classList.toggle('visible',window.scrollY>400);
    },{passive:true});
    btn.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }
})();

/* ---------- TARRMU AUTH ---------- */
(function(){'use strict';
  if(window.TarrmuAuth) return;

  var SB_URL=window.Tarrmu.SB_URL, SB_ANON=window.Tarrmu.SB_ANON;
  var AUTH_BRIDGE_URL=SB_URL+'/functions/v1/auth-bridge';
  var TOKEN_KEY='tarrmu_sb_token';

  function fire(detail){
    window.dispatchEvent(new CustomEvent('tarrmu-auth-ready',{detail:detail}));
  }

  var TarrmuAuth={
    member:null, ghostUuid:null, ready:false,

    init:function(){
      var self=this;
      return fetch('/members/api/session',{credentials:'include'}).then(function(sessionRes){
        if(sessionRes.status!==200){
          self.ready=true; fire({loggedIn:false});
          return;
        }
        return sessionRes.text().then(function(raw){
          var ghostToken=raw.trim();
          return fetch('/members/api/member/',{credentials:'include'}).then(function(memberRes){
            return memberRes.ok?memberRes.json():null;
          }).then(function(member){
            self.member=member;

            var cached=self._readCache();
            if(cached&&cached.token){
              self.ghostUuid=cached.ghost_uuid;
              self.ready=true;
              fire({loggedIn:true,member:self.member,ghostUuid:self.ghostUuid});
              return;
            }

            return fetch(AUTH_BRIDGE_URL,{
              method:'POST',
              headers:{'Content-Type':'application/json','apikey':SB_ANON},
              body:JSON.stringify({ghost_token:ghostToken})
            }).then(function(bridgeRes){
              if(!bridgeRes.ok){
                return bridgeRes.text().then(function(t){
                  console.error('[TarrmuAuth] bridge failed',t);
                  self.ready=true; fire({loggedIn:false});
                });
              }
              return bridgeRes.json().then(function(data){
                self._writeCache({token:data.token,ghost_uuid:data.ghost_uuid,expires_at:data.expires_at});
                self.ghostUuid=data.ghost_uuid;
                self.ready=true;
                fire({loggedIn:true,member:self.member,ghostUuid:self.ghostUuid});
              });
            });
          });
        });
      }).catch(function(err){
        console.error('[TarrmuAuth] init failed',err);
        self.ready=true; fire({loggedIn:false});
      });
    },

    _readCache:function(){
      try{
        var raw=sessionStorage.getItem(TOKEN_KEY);
        if(!raw) return null;
        var parsed=JSON.parse(raw);
        /* expiry gate: only trust a cache entry that carries a numeric
           future expires_at (ms epoch). Legacy entries written before the
           bridge returned expires_at have no expiry field and would
           otherwise be served forever as a stale JWT (401 on every RPC). */
        var exp=parsed.expires_at;
        if(typeof exp!=='number' || exp<1e12){ exp=(typeof exp==='number'&&exp<1e12)?exp*1000:0; }
        if(Date.now()>exp-5*60*1000){ sessionStorage.removeItem(TOKEN_KEY); return null; }
        return parsed;
      }catch(e){ return null; }
    },
    _writeCache:function(data){ try{ sessionStorage.setItem(TOKEN_KEY,JSON.stringify(data)); }catch(e){} },
    signOut:function(){
      sessionStorage.removeItem(TOKEN_KEY);
      this.member=null; this.ghostUuid=null;
    }
  };

  window.TarrmuAuth=TarrmuAuth;
  TarrmuAuth.init();
})();

/* ---------- TARRMU YOUTUBE FACADE ---------- */
(function(){'use strict';
  function getYouTube(src){
    if(!src) return null;
    try{
      var u=new URL(src,location.href);
      if(!/(^|\.)youtube(-nocookie)?\.com$|(^|\.)youtu\.be$/.test(u.hostname)) return null;
      var id=null, m=u.pathname.match(/\/embed\/([^/?#]+)/);
      if(m) id=m[1];
      else if(u.hostname==='youtu.be') id=u.pathname.slice(1);
      else if(u.searchParams.get('v')) id=u.searchParams.get('v');
      if(!id) return null;
      return { id:id, start:u.searchParams.get('start') };
    }catch(e){ return null; }
  }
  function buildFacade(info){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='tarmu-yt-facade';
    btn.setAttribute('aria-label','Play video');
    var img=document.createElement('img');
    img.loading='lazy'; img.decoding='async'; img.alt='Video thumbnail';
    img.src='https://i.ytimg.com/vi/'+info.id+'/maxresdefault.jpg';
    img.onerror=function(){ this.onerror=null; this.src='https://i.ytimg.com/vi/'+info.id+'/mqdefault.jpg'; };
    var play=document.createElement('span');
    play.className='tarmu-yt-play';
    btn.appendChild(img); btn.appendChild(play);
    btn.addEventListener('click',function(){
      var iframe=document.createElement('iframe');
      var src='https://www.youtube.com/embed/'+info.id+'?autoplay=1&rel=0';
      if(info.start) src+='&start='+info.start;
      iframe.src=src;
      iframe.className='tarmu-yt-iframe';
      iframe.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen','');
      iframe.setAttribute('frameborder','0');
      btn.replaceWith(iframe);
    },{once:true});
    return btn;
  }
  window.Tarrmu.onReady(function(){
    var frames=document.querySelectorAll('iframe');
    Array.prototype.forEach.call(frames,function(frame){
      var info=getYouTube(frame.getAttribute('src'));
      if(!info) return;
      var wrapper=frame.closest('.kg-embed-card')||frame.closest('figure')||frame;
      wrapper.replaceWith(buildFacade(info));
    });
  });
})();

/* ---------- TARRMU CUSTOM COMMENTS ---------- */
(function(){'use strict';
  var b=document.body;
  if(!b||!b.classList.contains('post-template')) return;

  var POST_SLUG=(function(){ var p=location.pathname.split('/').filter(Boolean); return p.length?p[p.length-1]:''; })();
  if(!POST_SLUG) return;

  var U=window.Tarrmu, XP=window.TarrmuXP;
  var MAXLEN=4000;
  var FN=U.SB_URL+'/functions/v1/moderate-comment';

  function ownName(){
    var m=window.TarrmuAuth&&window.TarrmuAuth.member;
    return m?(m.name||m.email||null):null;
  }
  function profileHref(c){
    if(c.is_mine) return '/user-profile/';
    if(c.username) return '/user-profile/?u='+encodeURIComponent(c.username);
    return null;
  }
  function me(){ return (window.TarrmuAuth&&window.TarrmuAuth.ghostUuid)?window.TarrmuAuth.ghostUuid:null; }

  var REJECT_COPY={
    content_rejected:      '// COMMENT BLOCKED \u2014 THIS BREACHES COMMUNITY GUIDELINES',
    not_authenticated:     '// SESSION EXPIRED \u2014 RELOAD THE PAGE AND SIGN IN AGAIN',
    moderation_unavailable:'// SCREENING UNAVAILABLE \u2014 TRY AGAIN SHORTLY',
    empty_body:            '// COMMENT IS EMPTY',
    too_long:              '// COMMENT IS TOO LONG',
    not_yours:             '// THAT IS NOT YOUR COMMENT',
    not_found:             '// COMMENT NO LONGER EXISTS',
    not_editable:          '// THIS COMMENT CANNOT BE EDITED',
    write_failed:          '// COULD NOT SAVE \u2014 TRY AGAIN',
    internal_error:        '// SOMETHING WENT WRONG \u2014 TRY AGAIN'
  };

  async function callFn(payload){
    var t=U.token();
    if(!t) return { ok:false, reason:'not_authenticated' };
    try{
      var r=await fetch(FN,{
        method:'POST',
        headers:{'Content-Type':'application/json','apikey':U.SB_ANON,'Authorization':'Bearer '+t},
        body:JSON.stringify(payload)
      });
      return await r.json().catch(function(){ return { ok:false, reason:'internal_error' }; });
    }catch(e){
      console.warn('[tc] fn call failed',e);
      return { ok:false, reason:'moderation_unavailable' };
    }
  }
  function reasonText(res){
    return REJECT_COPY[(res&&res.reason)||'internal_error']||REJECT_COPY.internal_error;
  }

  /* ---------- @mentions ---------- */
  // Render comment bodies: escape everything, then linkify @[Name](handle)
  // tokens to profile links and http(s) URLs to external links. The token
  // grammar matches what moderate-comment stores; the edit box repopulates
  // from the RAW body (stashed on the element), never from this rendered DOM.
  var MENTION_RE_SRC='@\\[([^\\]]{1,80})\\]\\(([A-Za-z0-9_]{1,30})\\)';
  function linkifyBody(raw){
    raw=(raw==null?'':String(raw));
    var re=new RegExp(MENTION_RE_SRC+'|https?:\\/\\/[^\\s<>"\']+','g');
    var out='',last=0,m;
    while((m=re.exec(raw))!==null){
      out+=U.esc(raw.slice(last,m.index));
      if(m[1]!==undefined){
        var handle=String(m[2]).toLowerCase();
        out+='<a class="tc-mention" href="/user-profile/?u='+encodeURIComponent(handle)+'">@'+U.esc(m[1])+'</a>';
      }else{
        var url=m[0],trail='';
        while(url.length){
          var ch=url.charAt(url.length-1);
          if('.,;:!?'.indexOf(ch)!==-1){ trail=ch+trail; url=url.slice(0,-1); continue; }
          if(ch===')'&&url.split(')').length>url.split('(').length){ trail=ch+trail; url=url.slice(0,-1); continue; }
          if(ch===']'&&url.split(']').length>url.split('[').length){ trail=ch+trail; url=url.slice(0,-1); continue; }
          break;
        }
        var safe=U.safeUrl(url);
        out+=safe?('<a class="tc-mention tc-extlink" href="'+U.esc(safe)+'" target="_blank" rel="nofollow noopener noreferrer">'+U.esc(url)+'</a>'):U.esc(url);
        out+=U.esc(trail);
      }
      last=m.index+m[0].length;
    }
    out+=U.esc(raw.slice(last));
    return out;
  }

  // search_mentionable_members is authenticated-only; U.rpc sends the member
  // token. Returns username + display_name + avatar_url (never ghost_uuid).
  function searchMembers(term){
    return U.rpc('search_mentionable_members',{ p_query:term, p_limit:8 })
      .then(function(r){ return Array.isArray(r)?r:[]; })
      .catch(function(e){ console.warn('[tc] member search failed',e); return []; });
  }

  var _mpickCss=false;
  function injectMentionCSS(){
    if(_mpickCss) return; _mpickCss=true;
    var s=document.createElement('style');
    s.id='tc-mention-css';
    s.textContent=
      '#tc-root .tc-composer,#tc-root .tc-replybox{position:relative}'+
      '#tc-root .tc-mention{color:var(--tc-purple);background:var(--tc-tint);font-weight:600;padding:0 3px;text-decoration:none;word-break:break-word}'+
      '#tc-root .tc-mention:hover{background:var(--tc-purple);color:#fff;text-decoration:none}'+
      '#tc-root .tc-mpick{position:absolute;z-index:60;background:var(--tc-panel);border:2px solid var(--tc-purple);max-height:248px;overflow-y:auto;box-shadow:0 10px 28px rgba(0,0,0,.5)}'+
      '#tc-root .tc-mpick-item{display:flex;align-items:center;gap:10px;padding:8px 10px;cursor:pointer;border-top:1px solid var(--tc-line)}'+
      '#tc-root .tc-mpick-item:first-child{border-top:none}'+
      '#tc-root .tc-mpick-item.is-on,#tc-root .tc-mpick-item:hover{background:var(--tc-hover)}'+
      '#tc-root .tc-mpick-av{width:26px;height:26px;flex:0 0 26px;border-radius:50%;object-fit:cover;background:var(--tc-panel);border:1px solid var(--tc-purple);display:flex;align-items:center;justify-content:center;font-size:11px;color:var(--tc-purple);font-weight:700}'+
      '#tc-root .tc-mpick-nm{font-size:13px;color:var(--tc-text);font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}'+
      '#tc-root .tc-mpick-h{font-size:11px;color:var(--tc-dim);margin-left:auto;flex-shrink:0}'+
      '#tc-root .tc-mpick-empty{padding:10px;font-size:12px;color:var(--tc-dim)}';
    document.head.appendChild(s);
  }

  function attachMentionPicker(ta){
    if(!ta||ta._mentionWired) return;
    ta._mentionWired=true;
    injectMentionCSS();

    var box=null,items=[],active=-1,region=null,debounceT=null,lastTerm=null;

    function close(){ if(box){ box.remove(); box=null; } items=[]; active=-1; region=null; lastTerm=null; }
    function ensureBox(){
      if(box) return box;
      box=document.createElement('div'); box.className='tc-mpick'; box.setAttribute('role','listbox');
      var host=ta.parentNode;
      if(host&&getComputedStyle(host).position==='static'){ host.style.position='relative'; }
      box.addEventListener('mousedown',function(ev){
        var item=ev.target.closest?ev.target.closest('.tc-mpick-item'):null;
        if(item){ ev.preventDefault(); pick(Number(item.getAttribute('data-i'))); }
      });
      host.appendChild(box);
      return box;
    }
    function place(){
      if(!box) return;
      box.style.top=(ta.offsetTop+ta.offsetHeight+4)+'px';
      box.style.left=ta.offsetLeft+'px';
      box.style.width=Math.min(ta.offsetWidth,380)+'px';
    }
    function render(){
      if(!box) return;
      if(!items.length){ box.innerHTML='<div class="tc-mpick-empty">No members found</div>'; return; }
      var html='';
      for(var i=0;i<items.length;i++){
        var it=items[i],nm=it.display_name||it.username;
        html+='<div class="tc-mpick-item'+(i===active?' is-on':'')+'" data-i="'+i+'" role="option">'+
          '<span class="tc-mpick-av" data-av="'+i+'">'+U.esc(U.initial(nm))+'</span>'+
          '<span class="tc-mpick-nm">'+U.esc(nm)+'</span>'+
          '<span class="tc-mpick-h">@'+U.esc(it.username)+'</span></div>';
      }
      box.innerHTML=html;
      box.querySelectorAll('[data-av]').forEach(function(slot){
        var it=items[Number(slot.getAttribute('data-av'))];
        var av=U.av(it&&it.avatar_url); if(!av) return;
        var img=document.createElement('img'); img.className='tc-mpick-av'; img.alt='';
        img.addEventListener('error',function(){ var d=document.createElement('span'); d.className='tc-mpick-av'; d.textContent=U.initial(it.display_name||it.username); img.replaceWith(d); });
        img.src=av; slot.replaceWith(img);
      });
    }
    function detectRegion(){
      var pos=ta.selectionStart;
      if(pos!==ta.selectionEnd) return null;
      var text=ta.value.slice(0,pos);
      var at=text.lastIndexOf('@');
      if(at===-1) return null;
      if(at>0&&!/\s/.test(text.charAt(at-1))) return null;
      var q=text.slice(at+1);
      if(/[\n\r]/.test(q)) return null;
      if(q.length>40) return null;
      return { start:at, end:pos, query:q };
    }
    function refresh(){
      var reg=detectRegion();
      if(!reg){ close(); return; }
      region=reg;
      var term=reg.query.trim();
      if(term.length<1){ close(); return; }
      if(term===lastTerm&&box){ place(); return; }
      lastTerm=term;
      clearTimeout(debounceT);
      debounceT=setTimeout(function(){
        searchMembers(term).then(function(res){
          var reg2=detectRegion();
          if(!reg2||reg2.query.trim()!==term) return;
          region=reg2; items=res; active=res.length?0:-1;
          ensureBox(); render(); place();
        });
      },140);
    }
    function pick(i){
      if(i<0||i>=items.length||!region) return;
      var it=items[i];
      var nm=String(it.display_name||it.username).replace(/[\[\]]/g,'').trim()||it.username;
      var token='@['+nm+']('+String(it.username).toLowerCase()+') ';
      var before=ta.value.slice(0,region.start),after=ta.value.slice(region.end);
      ta.value=before+token+after;
      var caret=(before+token).length;
      close(); ta.focus();
      try{ ta.setSelectionRange(caret,caret); }catch(e){}
      ta.dispatchEvent(new Event('input',{bubbles:true}));
    }

    ta.addEventListener('input',refresh);
    ta.addEventListener('click',refresh);
    ta.addEventListener('keyup',function(ev){
      if(ev.key==='ArrowLeft'||ev.key==='ArrowRight'||ev.key==='Home'||ev.key==='End') refresh();
    });
    ta.addEventListener('keydown',function(ev){
      if(!box||!items.length) return;
      if(ev.key==='ArrowDown'){ ev.preventDefault(); active=(active+1)%items.length; render(); }
      else if(ev.key==='ArrowUp'){ ev.preventDefault(); active=(active-1+items.length)%items.length; render(); }
      else if(ev.key==='Enter'||ev.key==='Tab'){ if(active>=0){ ev.preventDefault(); pick(active); } }
      else if(ev.key==='Escape'){ ev.preventDefault(); close(); }
    });
    ta.addEventListener('blur',function(){ setTimeout(close,120); });
  }

  var root, wired=false;

  function listMsg(list,cls,text){
    list.textContent='';
    var d=document.createElement('div');
    d.className=cls;
    d.textContent=text;
    list.appendChild(d);
  }

  function mount(){
    var existing=document.getElementById('tc-root');
    if(existing) return existing;
    var anchor=document.querySelector('.gh-article')
            ||document.querySelector('article')
            ||document.querySelector('.gh-content')
            ||document.querySelector('main');
    if(!anchor){ console.warn('[tc] no anchor element found \u2014 cannot mount'); return null; }
    var r=document.createElement('section');
    r.id='tc-root';
    r.innerHTML='<div class="tc-head">// COMMENTS <b class="tc-cnt"></b></div>'+
      '<div class="tc-composer-slot"></div>'+
      '<div class="tc-list"><div class="tc-skel"></div><div class="tc-skel"></div></div>';
    if(anchor.parentNode){ anchor.parentNode.insertBefore(r,anchor.nextSibling); }
    else { anchor.appendChild(r); }
    return r;
  }

  function composerEl(){
    var w=document.createElement('div'); w.className='tc-panel tc-composer';
    if(!me()){
      w.innerHTML='<div class="tc-signin">Please <a href="/#/portal/signin">sign in</a> to join the conversation.</div>';
      return w;
    }
    w.innerHTML='<textarea class="tc-ta" maxlength="'+MAXLEN+'" placeholder="Add a comment\u2026"></textarea>'+
      '<div class="tc-row"><span class="tc-count">0 / '+MAXLEN+'</span>'+
      '<button class="tc-btn tc-submit" data-act="submit-top" disabled>Post</button></div>'+
      '<div class="tc-err" style="display:none"></div>';
    attachMentionPicker(w.querySelector('.tc-ta'));
    return w;
  }
  function boxEl(act,id,current){
    var b=document.createElement('div'); b.className='tc-replybox';
    var label=act==='edit-save'?'Save':'Reply';
    b.innerHTML='<textarea class="tc-ta" maxlength="'+MAXLEN+'" placeholder="'+(act==='edit-save'?'':'Write a reply\u2026')+'"></textarea>'+
      '<div class="tc-row"><span class="tc-count">0 / '+MAXLEN+'</span><span>'+
      '<button class="tc-act" data-act="'+(act==='edit-save'?'edit-cancel':'reply-cancel')+'">Cancel</button> &nbsp;'+
      '<button class="tc-btn tc-submit" data-act="'+act+'" data-id="'+id+'" disabled>'+label+'</button></span></div>'+
      '<div class="tc-err" style="display:none"></div>';
    if(current!=null){ b.querySelector('.tc-ta').value=current; }
    return b;
  }

  function commentEl(c,isReply){
    var el=document.createElement('div');
    el.className='tc-c'+(isReply?' tc-reply':'');
    el.setAttribute('data-id',c.id);
    if(c.status==='deleted'){
      el.innerHTML='<div class="tc-av">\u2013</div><div class="tc-body-wrap">'+
        '<div class="tc-c-text tc-removed">This comment was removed.</div>'+
        '<div class="tc-replybox-slot"></div></div>';
      return el;
    }
    var lvl=XP.levelFromXp(c.xp), rank=XP.rankFromLevel(lvl), av=U.av(c.avatar_url);
    var mine=!!c.is_mine;
    var nameToShow=c.display_name||(mine?ownName():null)||'Anonymous';
    var acts='';
    if(!isReply&&me()) acts+='<button class="tc-act" data-act="reply">Reply</button>';
    if(mine){ acts+='<button class="tc-act" data-act="edit">Edit</button>'+
                    '<button class="tc-act" data-act="delete">Delete</button>'; }
    el.innerHTML=
      (av?'<img class="tc-av" alt="">':'<div class="tc-av"></div>')+
      '<div class="tc-body-wrap">'+
        '<div class="tc-meta">'+
          '<span class="tc-name"></span>'+
          '<span class="tc-date"></span>'+
          (c.edited_at?'<span class="tc-edited"></span>':'')+
          '<span class="trk-break"></span>'+XP.rankBadge(lvl)+
        '</div>'+
        '<div class="tc-c-text"></div>'+
        '<div class="tc-actions">'+acts+'</div>'+
        '<div class="tc-replybox-slot"></div>'+
      '</div>';
    var nameEl=el.querySelector('.tc-name');
    var href=profileHref(c);
    if(href){
      var a=document.createElement('a');
      a.className='tc-name-link';
      a.href=href;
      a.textContent=nameToShow;
      nameEl.appendChild(a);
    } else {
      nameEl.textContent=nameToShow;
    }
    var dateEl=el.querySelector('.tc-date');
    dateEl.textContent=U.timeAgo(c.created_at);
    dateEl.title=new Date(c.created_at).toLocaleString();
    if(c.edited_at){
      var ed=el.querySelector('.tc-edited');
      ed.textContent='(edited '+U.timeAgo(c.edited_at)+')';
      ed.title=new Date(c.edited_at).toLocaleString();
    }
    el.querySelector('.tc-c-text').innerHTML=linkifyBody(c.body||'');
    el._rawBody=c.body||'';   /* edit box repopulates from this, not the DOM */
    if(av){
      var img=el.querySelector('img.tc-av'); img.src=av;
      img.onerror=function(){ var d=document.createElement('div'); d.className='tc-av'; d.textContent=U.initial(nameToShow); img.replaceWith(d); };
    } else { el.querySelector('.tc-av').textContent=U.initial(nameToShow); }
    return el;
  }

  async function loadAndRender(){
    if(!root) return;
    var list=root.querySelector('.tc-list');
    var rows;
    try{
      rows=await U.rpc('get_post_comments',{ p_post_slug:POST_SLUG });
    }catch(e){
      console.error('[tc] rpc failed',e);
      listMsg(list,'tc-err','Failed to load comments.');
      return;
    }
    rows=rows||[];
    var tops=[], kids={};
    rows.forEach(function(c){ if(c.parent_id==null) tops.push(c); else (kids[c.parent_id]=kids[c.parent_id]||[]).push(c); });
    root.querySelector('.tc-cnt').textContent=rows.filter(function(c){ return c.status!=='deleted'; }).length;
    if(!tops.length){ listMsg(list,'tc-empty','No comments yet. Be the first.'); return; }
    list.textContent='';
    tops.forEach(function(c){
      list.appendChild(commentEl(c,false));
      (kids[c.id]||[]).forEach(function(r){ list.appendChild(commentEl(r,true)); });
    });
  }

  function showErr(btn,msg){ var w=btn.closest('.tc-composer')||btn.closest('.tc-replybox'); if(!w) return;
    var e=w.querySelector('.tc-err'); if(e){ e.textContent=msg; e.style.display='block'; } }
  function clearErr(btn){ var w=btn.closest('.tc-composer')||btn.closest('.tc-replybox'); if(!w) return;
    var e=w.querySelector('.tc-err'); if(e){ e.textContent=''; e.style.display='none'; } }

  async function postComment(body,parentId,btn){
    if(!me()) return;
    btn.disabled=true; clearErr(btn);
    var payload={ surface:'comment', action:'create', post_slug:POST_SLUG, body:body };
    if(parentId) payload.parent_id=parentId;
    var res=await callFn(payload);
    if(!res||!res.ok){ showErr(btn,reasonText(res)); btn.disabled=false; return; }
    if(!parentId){
      var c=btn.closest('.tc-composer');
      c.querySelector('.tc-ta').value='';
      c.querySelector('.tc-count').textContent='0 / '+MAXLEN;
    }
    await loadAndRender();
  }

  async function editComment(id,body,btn){
    btn.disabled=true; clearErr(btn);
    var res=await callFn({ surface:'comment', action:'edit', id:id, body:body });
    if(!res||!res.ok){ showErr(btn,reasonText(res)); btn.disabled=false; return; }
    await loadAndRender();
  }

  async function deleteComment(id){
    if(!window.confirm('Delete this comment?')) return;
    var res=await callFn({ surface:'comment', action:'delete', id:id });
    if(!res||!res.ok){ console.warn('[tc] delete failed',res); return; }
    await loadAndRender();
  }

  function attach(){
    if(wired) return; wired=true;
    root.addEventListener('input',function(ev){
      var ta=ev.target; if(!ta.classList||!ta.classList.contains('tc-ta')) return;
      var w=ta.closest('.tc-composer')||ta.closest('.tc-replybox'); if(!w) return;
      var cnt=w.querySelector('.tc-count'); if(cnt) cnt.textContent=ta.value.length+' / '+MAXLEN;
      var sub=w.querySelector('.tc-submit'); if(sub) sub.disabled=ta.value.trim().length===0;
    });
    root.addEventListener('click',function(ev){
      var bt=ev.target.closest('[data-act]'); if(!bt) return;
      var act=bt.getAttribute('data-act');
      if(act==='submit-top'){ var t=root.querySelector('.tc-composer .tc-ta'); var v=t.value.trim(); if(v) postComment(v,null,bt); }
      else if(act==='reply'){ toggleBox(bt,'reply'); }
      else if(act==='edit'){ toggleBox(bt,'edit'); }
      else if(act==='reply-cancel'||act==='edit-cancel'){ var bx=bt.closest('.tc-replybox'); if(bx) bx.remove(); }
      else if(act==='reply-submit'){ var ta=bt.closest('.tc-replybox').querySelector('.tc-ta'); var rv=ta.value.trim();
        if(rv) postComment(rv,Number(bt.getAttribute('data-id')),bt); }
      else if(act==='edit-save'){ var ta2=bt.closest('.tc-replybox').querySelector('.tc-ta'); var ev2=ta2.value.trim();
        if(ev2) editComment(Number(bt.getAttribute('data-id')),ev2,bt); }
      else if(act==='delete'){ deleteComment(Number(bt.closest('.tc-c').getAttribute('data-id'))); }
    });
  }

  function toggleBox(btn,mode){
    var c=btn.closest('.tc-c'), slot=c.querySelector('.tc-replybox-slot');
    if(slot.querySelector('.tc-replybox')){ slot.querySelector('.tc-replybox').remove(); return; }
    root.querySelectorAll('.tc-replybox').forEach(function(x){ x.remove(); });
    var id=c.getAttribute('data-id'), box;
    if(mode==='edit'){
      /* raw stored body, so @[Name](handle) tokens survive the edit round-trip */
      var raw=(c._rawBody!=null)?c._rawBody:c.querySelector('.tc-c-text').textContent;
      box=boxEl('edit-save',id,raw);
    }
    else { box=boxEl('reply-submit',id,null); }
    slot.appendChild(box);
    var ta=box.querySelector('.tc-ta'); ta.focus();
    attachMentionPicker(ta);
    box.querySelector('.tc-count').textContent=ta.value.length+' / '+MAXLEN;
    box.querySelector('.tc-submit').disabled=ta.value.trim().length===0;
  }

  function refreshComposer(){
    if(!root) return;
    var cs=root.querySelector('.tc-composer-slot');
    if(cs){ cs.textContent=''; cs.appendChild(composerEl()); }
  }

  async function init(){
    try{
      await U.whenAuthReady(6000);
      root=mount();
      if(!root){ return; }
      injectMentionCSS();   /* style rendered @mentions even when signed out */
      refreshComposer();
      attach();
      await loadAndRender();
    }catch(err){
      console.error('[tc] init failed:',err);
    }
  }

  window.addEventListener('tarrmu-auth-ready',function(){
    if(!root){ init(); } else { refreshComposer(); }
  });
  window.addEventListener('pageshow',function(e){ if(e.persisted&&root) loadAndRender(); });

  U.onReady(init);
})();

/* ---------- TARRMU GLOBAL SEARCH + HEADER LAYOUT ---------- */
(function(){'use strict';
  if(window.__tarrmuSearch) return;
  window.__tarrmuSearch=true;

  var U=window.Tarrmu;
  var esc=U.esc;

  var MIN_CHARS=2;      /* must match global_search's own short-query guard */
  var DEBOUNCE_MS=220;
  var ALL_PREVIEW=3;
  var RESULT_LIMIT=20;  /* [KNOB] server clamps to 50 max */
  var RIGHT_INSET=28;   /* [EDIT] px from the right edge for the theme toggle */
  var DESKTOP_MIN=900;  /* header repositioning is desktop-only */
  var TOGGLE_ID='tarrmuTheme';  /* set in partials/components/navigation.hbs */
  var CATS=[
    { key:'all',      label:'ALL' },
    { key:'articles', label:'ARTICLES' },
    { key:'games',    label:'GAMES' },
    { key:'rereleases', label:'RE-RELEASES' },
    { key:'dlc',      label:'DLC' },
    { key:'characters', label:'CHARACTERS' },
    { key:'people',   label:'PEOPLE' },
    { key:'events',   label:'EVENTS' },
    { key:'users',    label:'USERS' }
  ];
  /* order here drives the ALL view's section order; must stay in step with
     global_search's own union order so previews read top-to-bottom the same */
  var SECTIONS=[
    { type:'article', label:'// ARTICLES', cat:'articles' },
    { type:'game',      label:'// GAMES',       cat:'games' },
    { type:'rerelease', label:'// RE-RELEASES', cat:'rereleases' },
    { type:'dlc',       label:'// DLC',         cat:'dlc' },
    { type:'character', label:'// CHARACTERS',  cat:'characters' },
    { type:'person',    label:'// PEOPLE',      cat:'people' },
    { type:'event',     label:'// EVENTS',      cat:'events' },
    { type:'user',    label:'// USERS',    cat:'users' }
  ];
  var ICONS={
    article:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="14" y2="17"/></svg>',
    game:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="11" x2="10" y2="11"/><line x1="8" y1="9" x2="8" y2="13"/><line x1="15" y1="12" x2="15.01" y2="12"/><line x1="18" y1="10" x2="18.01" y2="10"/><path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"/></svg>',
    dlc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    rerelease:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>',
    character:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="4"/><path d="M5.5 21a8.38 8.38 0 0 1 13 0"/><path d="M17 4l1.5 1.5M20 2.5l.5.5" stroke-dasharray=".1 2.4"/></svg>',
    person:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/><path d="M15 9l2 2 4-4"/></svg>',
    event:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    user:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
  };

  var overlay=null, input=null, resultsEl=null, countEl=null, catMenu=null, fieldEl=null;
  var category='all';
  var debounceTimer=null, aborter=null, lastQuery='';
  var navItems=[], selIdx=-1;
  var prevOverflow='';

  /* global_search is SECURITY DEFINER and anon-executable -- U.rpc sends the
     anon key when signed out, so Ctrl+K works before the auth-bridge mint
     resolves rather than showing a false "SEARCH UNAVAILABLE". */

  /* user rows: result_id is the username (subtitle is null since the @handle
     was suppressed server-side). articles/games carry a server-built url_path. */
  function hrefFor(r){
    if(r.result_type==='user'){
      return r.result_id?('/user-profile/?u='+encodeURIComponent(r.result_id)):'#';
    }
    return r.url_path||'#';
  }

  function build(){
    if(overlay) return;
    overlay=document.createElement('div');
    overlay.className='ts-overlay';
    overlay.innerHTML=
      '<div class="ts-modal" role="dialog" aria-modal="true" aria-label="Search">'+
        '<div class="ts-head">'+
          '<span class="ts-head-title">// Search</span>'+
          '<button class="ts-x" type="button" aria-label="Close search">&#10005;</button>'+
        '</div>'+
        '<div class="ts-bar">'+
          '<button class="ts-back" type="button" aria-label="Close search">&#8249;</button>'+
          '<span class="ts-field">'+
            '<span class="ts-prompt" aria-hidden="true">&gt;</span>'+
            '<input class="ts-input" type="text" autocomplete="off" spellcheck="false" placeholder="search games, articles, people, users&#8230;">'+
            '<button class="ts-clear" type="button" aria-label="Clear search">&#10005;</button>'+
          '</span>'+
          '</div>'+
        '<div class="ts-kinds" role="group" aria-label="Filter results"></div>'+
        '<div class="ts-results"></div>'+
        '<div class="ts-foot">'+
          '<span class="ts-keys"><b>&#8593;&#8595;</b> navigate &nbsp; <b>&#8629;</b> open &nbsp; <b>esc</b> close</span>'+
          '<span class="ts-count"></span>'+
        '</div>'+
      '</div>';
    document.body.appendChild(overlay);

    input=overlay.querySelector('.ts-input');
    fieldEl=overlay.querySelector('.ts-field');
    resultsEl=overlay.querySelector('.ts-results');
    countEl=overlay.querySelector('.ts-count');
    /* 4_1_194: tag chips replace the [ ALL ] dropdown (catMenu kept as the chip row) */
    catMenu=overlay.querySelector('.ts-kinds');

    catMenu.innerHTML=CATS.map(function(c){
      return '<button class="ts-kind'+(c.key===category?' ts-on':'')+'" type="button" data-cat="'+c.key+'" aria-pressed="'+(c.key===category)+'">'+c.label+'</button>';
    }).join('');

    blankState();

    overlay.addEventListener('click',function(e){
      if(e.target===overlay){ close(); return; }
      if(e.target.closest('.ts-x')||e.target.closest('.ts-back')){ close(); return; }
      if(e.target.closest('.ts-clear')){
        input.value='';
        fieldEl.classList.remove('ts-has-q');
        input.focus();
        runSearch(true);
        return;
      }
      var opt=e.target.closest('.ts-kind');
      if(opt){ setCategory(opt.getAttribute('data-cat')); return; }
      var more=e.target.closest('.ts-more');
      if(more){ setCategory(more.getAttribute('data-cat')); return; }
      var row=e.target.closest('.ts-row');
      if(row&&row.getAttribute('data-href')){ location.href=row.getAttribute('data-href'); return; }
      catMenu.classList.remove('ts-open');
    });

    input.addEventListener('input',function(){
      fieldEl.classList.toggle('ts-has-q',input.value.length>0);
      clearTimeout(debounceTimer);
      debounceTimer=setTimeout(runSearch,DEBOUNCE_MS);
    });
    input.addEventListener('keydown',function(e){
      if(e.key==='ArrowDown'){ e.preventDefault(); moveSel(1); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); moveSel(-1); }
      else if(e.key==='Enter'){
        if(selIdx>=0&&navItems[selIdx]) location.href=navItems[selIdx].href;
        else if(navItems.length) location.href=navItems[0].href;
      }
    });
  }

  function setCategory(key){
    category=key;
    catMenu.querySelectorAll('.ts-kind').forEach(function(o){
      var on=o.getAttribute('data-cat')===key;
      o.classList.toggle('ts-on',on); o.setAttribute('aria-pressed',String(on));
      if(on&&o.scrollIntoView) o.scrollIntoView({ block:'nearest', inline:'nearest' });
    });
    input.focus();
    runSearch(true);
  }

  function moveSel(dir){
    if(!navItems.length) return;
    selIdx=(selIdx+dir+navItems.length)%navItems.length;
    navItems.forEach(function(it,i){ it.el.classList.toggle('ts-sel',i===selIdx); });
    navItems[selIdx].el.scrollIntoView({ block:'nearest' });
  }

  /* The old empty state was a single "TYPE TO SEARCH" line, which on a phone
     left roughly 300px of dot-grid doing nothing. These rows fill it with the
     three destinations that are hardest to reach from the burger menu, and
     they reuse .ts-row/.ts-ic so no new CSS is needed. Registering them in
     navItems keeps arrow-key navigation working on desktop. */
  var JUMPS=[
    { href:'/video-game-release-calendar/', title:'Release calendar',  icon:'game'    },
    { href:'/game-of-the-year-leaderboard/', title:'GOTY leaderboard', icon:'article' },
    { href:'/community-hub/',               title:'Community hub',     icon:'user'    }
  ];

  function blankState(){
    resultsEl.innerHTML='<div class="ts-section">// JUMP TO</div>'+
      JUMPS.map(function(j){
        return '<div class="ts-row" data-href="'+esc(j.href)+'">'+
          '<div class="ts-ic ts-ic-'+j.icon+'">'+ICONS[j.icon]+'</div>'+
          '<div class="ts-txt"><div class="ts-title">'+esc(j.title)+'</div></div></div>';
      }).join('');
    countEl.textContent='';
    navItems=[]; selIdx=-1;
    resultsEl.querySelectorAll('.ts-row').forEach(function(el){
      navItems.push({ el:el, href:el.getAttribute('data-href') });
    });
  }

  function note(msg){
    resultsEl.innerHTML='<div class="ts-note">'+esc(msg)+'</div>';
    countEl.textContent='';
    navItems=[]; selIdx=-1;
  }

  /* every interpolated value passes through esc(); image_url additionally
     gated on an http(s) scheme. title carries display_name (member-set). */
  function rowHTML(r){
    var href=hrefFor(r);
    var type=esc(r.result_type);
    var ic;
    if(r.image_url&&/^https?:\/\//i.test(r.image_url)){
      ic='<div class="ts-ic ts-ic-'+type+'" data-type="'+type+'"><img src="'+esc(r.image_url)+'" alt="" loading="lazy" decoding="async"></div>';
    } else {
      ic='<div class="ts-ic ts-ic-'+type+'">'+(ICONS[r.result_type]||ICONS.article)+'</div>';
    }
    return '<div class="ts-row" data-href="'+esc(href)+'">'+ic+
      '<div class="ts-txt"><div class="ts-title">'+esc(r.title)+'</div>'+
      (r.subtitle?'<div class="ts-sub">'+esc(r.subtitle)+'</div>':'')+
      '</div></div>';
  }

  function render(rows,q){
    navItems=[]; selIdx=-1;
    if(!rows.length){ note('NO RESULTS FOR \u201C'+q+'\u201D'); return; }
    var html='';

    if(category==='all'){
      SECTIONS.forEach(function(sec){
        var group=rows.filter(function(r){ return r.result_type===sec.type; });
        if(!group.length) return;
        html+='<div class="ts-section">'+sec.label+'</div>';
        group.slice(0,ALL_PREVIEW).forEach(function(r){ html+=rowHTML(r); });
        if(group.length>ALL_PREVIEW){
          html+='<button type="button" class="ts-more" data-cat="'+sec.cat+'">Show all '+sec.label.replace('// ','').toLowerCase().replace('dlc','DLC')+' &#8594;</button>';
        }
      });
    } else {
      var sec=SECTIONS.filter(function(s){ return s.cat===category; })[0];
      html+='<div class="ts-section">'+(sec?sec.label:'// RESULTS')+'</div>';
      rows.forEach(function(r){ html+=rowHTML(r); });
    }

    resultsEl.innerHTML=html;
    resultsEl.querySelectorAll('.ts-ic > img').forEach(function(img){
      img.onerror=function(){
        var tile=img.parentElement;
        tile.innerHTML=ICONS[tile.getAttribute('data-type')]||ICONS.article;
      };
    });
    resultsEl.querySelectorAll('.ts-row').forEach(function(el){
      navItems.push({ el:el, href:el.getAttribute('data-href') });
    });
    var visible=navItems.length;
    countEl.textContent=visible+(visible===1?' result':' results');
  }

  async function runSearch(force){
    var q=input.value.trim();
    if(q===lastQuery&&!force) return;
    lastQuery=q;

    if(q.length<MIN_CHARS){ blankState(); return; }

    if(aborter) aborter.abort();
    aborter=new AbortController();
    countEl.textContent='searching\u2026';

    var rows;
    try{
      rows=await U.anonRpc('global_search',{
        search_query:q,
        search_category:category,
        result_limit:RESULT_LIMIT,
        result_offset:0
      },aborter.signal);
    }catch(e){
      if(e&&e.name==='AbortError') return;
      console.error('[ts] search failed',e);
      note('SEARCH FAILED');
      return;
    }
    render(rows||[],q);
  }

  function open(){
    build();
    prevOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    overlay.classList.add('ts-open');
    input.focus();
    input.select();
  }
  function close(){
    if(!overlay) return;
    overlay.classList.remove('ts-open');
    catMenu.classList.remove('ts-open');
    document.body.style.overflow=prevOverflow;
  }
  function isOpen(){ return overlay&&overlay.classList.contains('ts-open'); }

  document.addEventListener('click',function(e){
    var trig=e.target.closest('[data-ghost-search]');
    if(!trig) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  },true);

  function checkHash(){
    if(location.hash==='#/search'){
      history.replaceState(null,'',location.pathname+location.search);
      open();
    }
  }
  window.addEventListener('hashchange',checkHash);
  checkHash();

  document.addEventListener('keydown',function(e){
    if((e.ctrlKey||e.metaKey)&&(e.key==='k'||e.key==='K')){
      e.preventDefault();
      isOpen()?close():open();
      return;
    }
    if(e.key==='Escape'&&isOpen()){ close(); return; }
    if(e.key==='/'&&!isOpen()){
      var t=e.target;
      var typing=t&&(t.tagName==='INPUT'||t.tagName==='TEXTAREA'||t.isContentEditable);
      if(!typing){ e.preventDefault(); open(); }
    }
  });

  /* ============ HEADER LAYOUT ============
     One module for: search trigger relocation + styling, account-cluster
     positioning, theme-toggle positioning, and chip height sync.

     This site's header does not use Source's stock .gh-head class, so
     positioning has to be done with inline style.setProperty(...,'important')
     -- CSS selectors do not win here. That makes measurement unavoidable, so
     it has to be cheap, it has to be batched, and it must not run on mobile.

     PERF HISTORY -- two bugs lived here, both costing main-thread time:

     1. findToggle() identified the theme toggle by looking for a child of the
        account cluster with EMPTY textContent. The button is server-rendered
        by partials/components/navigation.hbs as
            <button class="t-toggle" id="tarrmuTheme">&#9728;</button>
        -- the sun glyph means textContent is never empty, so the heuristic
        never matched anything. It now matches on the id, which is stable.

     2. applyClusterPos() and positionToggle() were separate functions called
        back to back. The first wrote posCluster.style.position='absolute';
        the second immediately read posCluster.getBoundingClientRect(). A read
        after a write on the same element forces a synchronous reflow -- and
        the value it recomputed was the one that had just been written. They
        are now one function: every read first, every write after, one layout.

     Consequence of (1): startToggle() polled every 100ms for 3s doing
     getComputedStyle + getBoundingClientRect per tick and always failed. The
     poll is gone -- the toggle is in the parsed document, so if it is not
     there at DOMContentLoaded it is never coming. */
  var posCluster=null, posHead=null, toggleRef=null;

  function isDesktop(){ return window.innerWidth>=DESKTOP_MIN; }

  function isLightTheme(){
    var h=document.documentElement, b=document.body;
    return h.getAttribute('data-theme')==='light'
        ||h.classList.contains('light')
        ||(b&&(b.classList.contains('light')||b.classList.contains('theme-light')));
  }
  function lookupColors(){
    return isLightTheme()
      ? { purple:'#6a61c9', tint:'rgba(106,97,201,0.12)', fg:'#0d0d0d' }
      : { purple:'#7F77DD', tint:'rgba(127,119,221,0.12)', fg:'#ffffff' };
  }
  function styleLookup(btn){
    var c=lookupColors();
    var set=function(p,v){ btn.style.setProperty(p,v,'important'); };
    set('display','inline-flex');
    set('align-items','center');
    set('justify-content','center');
    set('gap','8px');
    set('padding','9px 14px');
    set('background','transparent');
    set('border','2px solid '+c.purple);
    set('border-radius','0');
    set('color',c.purple);
    set('font-family','"JetBrains Mono", Menlo, Consolas, Monaco, monospace');
    set('box-shadow','none');
    set('cursor','pointer');
    set('transform','none');
    set('transition','background .12s ease, border-color .12s ease');
    var lbl=btn.querySelector('.ts-lookup-label');
    if(lbl){
      var ls=function(p,v){ lbl.style.setProperty(p,v,'important'); };
      /* Explicit, not inherit: the button's own colour stays purple so the
         magnifier icon (stroke="currentColor") keeps the accent. The label
         tracks the theme instead -- white on dark, near-black on light. */
      ls('color',c.fg);
      ls('font-size','12px');
      ls('font-weight','700');
      ls('line-height','1');
      ls('letter-spacing','0.1em');
      ls('white-space','nowrap');
    }
    var ic=btn.querySelector('.ts-lookup-ic');
    if(ic){
      ic.style.setProperty('width','15px','important');
      ic.style.setProperty('height','15px','important');
      ic.style.setProperty('display','block','important');
      ic.style.setProperty('flex','0 0 auto','important');
    }
  }
  function wireLookupHover(btn){
    if(btn.__tsHover) return; btn.__tsHover=true;
    btn.addEventListener('mouseenter',function(){
      var c=lookupColors();
      /* No solid fill and no shadow: hover is a faint tint plus a border that
         brightens to the theme foreground, matching .gh-support. */
      btn.style.setProperty('background',c.tint,'important');
      btn.style.setProperty('border-color',c.fg,'important');
    });
    btn.addEventListener('mouseleave',function(){ styleLookup(btn); });
  }
  function watchThemeToggle(btn){
    if(watchThemeToggle._wired) return; watchThemeToggle._wired=true;
    var mo=new MutationObserver(function(){ styleLookup(btn); });
    mo.observe(document.documentElement,{ attributes:true, attributeFilter:['data-theme','class'] });
    if(document.body) mo.observe(document.body,{ attributes:true, attributeFilter:['class'] });
  }

  function clearClusterPos(){
    if(!posCluster) return;
    ['order','marginLeft','gridColumn','justifySelf','position','right','top','zIndex']
      .forEach(function(p){ posCluster.style[p]=''; });
  }
  function contentRightInset(hr){
    var probe=document.querySelector('.gh-main .gh-inner')
           ||document.querySelector('.gh-outer .gh-inner')
           ||document.querySelector('.gh-inner')
           ||document.querySelector('main');
    if(probe){
      var pr=probe.getBoundingClientRect();
      if(pr.width>300&&pr.right>window.innerWidth*0.55){
        return Math.max(16,Math.round(hr.right-pr.right));
      }
    }
    return 28;
  }

  /* the toggle is server-rendered with a stable id -- no heuristics, no poll. */
  function findToggle(){
    if(toggleRef&&document.contains(toggleRef)) return toggleRef;
    var t=document.getElementById(TOGGLE_ID);
    if(t) toggleRef=t;
    return t;
  }

  /* ONE measure/mutate pass for the cluster, the toggle and the chip.
     Nothing below the READS marker may read layout; nothing above the WRITES
     marker may write it. Keep it that way -- interleaving is what forced the
     synchronous reflow this function was written to remove. */
  function layoutHeader(){
    if(!posCluster||!posHead||!isDesktop()) return false;
    var toggle=findToggle();
    var chip=document.getElementById('tarrmu-profile-chip');

    /* ---------- READS ---------- */
    var hr=posHead.getBoundingClientRect();
    var cr=posCluster.getBoundingClientRect();
    var inset=contentRightInset(hr);
    var headIsStatic=getComputedStyle(posHead).position==='static';
    var topOffset=Math.max(0,Math.round(cr.top-hr.top));
    var toggleH=toggle?toggle.offsetHeight:0;
    var toggleW=toggle?toggle.offsetWidth:0;

    /* ---------- WRITES ---------- */
    if(headIsStatic) posHead.style.position='relative';
    posCluster.style.position='absolute';
    posCluster.style.right=inset+'px';
    posCluster.style.top=topOffset+'px';
    posCluster.style.zIndex='5';

    if(toggle){
      /* The toggle is floated at the far right (right:28px) only when the
         gutter between the viewport edge and the members cluster actually
         fits it: it needs RIGHT_INSET + its own width, plus a small gap, of
         clear space to the cluster's right edge (inset). Below ~1400px that
         space is ~32px and the 66px-wide float used to sit ON TOP of the
         profile chip (z-index 6 over the cluster's 5) -- reported as the
         light/dark button overlapping the user chip on smaller screens.
         When the gutter is too narrow, drop the float and let the toggle
         live inside the cluster's flex row (its natural DOM position, right
         after the search button), where it can never overlap anything. */
      var gutterFits=inset-RIGHT_INSET>=toggleW+12;
      if(gutterFits){
        if(toggle.parentElement!==posHead) posHead.appendChild(toggle);
        toggle.style.setProperty('position','absolute','important');
        toggle.style.setProperty('right',RIGHT_INSET+'px','important');
        toggle.style.setProperty('top',topOffset+'px','important');
        toggle.style.setProperty('z-index','6','important');
        toggle.style.setProperty('margin','0','important');
        toggle.style.setProperty('visibility','visible','important');
      }else{
        if(toggle.parentElement!==posCluster){
          /* after the search button (relocateTrigger moves it to firstChild) */
          posCluster.insertBefore(toggle,posCluster.children[1]||null);
        }
        ['position','right','top','z-index','margin','visibility']
          .forEach(function(p){ toggle.style.removeProperty(p); });
      }
    }
    if(chip&&toggleH) chip.style.setProperty('height',toggleH+'px','important');
    return !!toggle;
  }

  /* the profile chip mounts after auth resolves, long after layoutHeader ran,
     so it needs its own entry point. This is a read-then-write with no write
     before it, so it does not force a reflow. */
  function syncChipHeight(){
    var chip=document.getElementById('tarrmu-profile-chip');
    if(!chip||!toggleRef) return false;
    var h=toggleRef.offsetHeight;          /* read */
    if(!h) return false;
    chip.style.setProperty('height',h+'px','important');   /* write */
    return true;
  }
  /* exposed so the profile chip syncs on mount instead of polling */
  U.header={ syncChipHeight:syncChipHeight };

  function relocateTrigger(){
    var head=document.querySelector('#gh-head, .gh-head, header');
    if(!head){ console.warn('[ts] relocate: no header found'); return; }

    var searches=Array.prototype.slice.call(head.querySelectorAll('[data-ghost-search]'));
    if(!searches.length){ console.warn('[ts] relocate: no [data-ghost-search] in header'); return; }
    var btn=searches.filter(function(el){ return el.offsetParent!==null; })[0]||searches[0];

    var account=Array.prototype.filter.call(
      head.querySelectorAll('a, button'),
      function(el){
        if(el===btn||el.closest('[data-ghost-search]')) return false;
        var t=(el.textContent||'').trim();
        return /^(account|sign ?in|log ?in|subscribe)$/i.test(t);
      }
    )[0];

    var cluster=account?account.parentElement:head.querySelector('.gh-head-actions');
    if(!cluster){ console.warn('[ts] relocate: no account cluster found \u2014 leaving search where it is'); return; }
    if(cluster.querySelector('.gh-head-logo')||cluster.children.length>6){
      console.warn('[ts] relocate: cluster looks too broad \u2014 skipping reposition to avoid moving the logo');
      return;
    }

    if(cluster.firstElementChild!==btn){
      cluster.insertBefore(btn,cluster.firstElementChild);
      btn.classList.add('ts-moved');
      searches.forEach(function(el){ if(el!==btn) el.classList.add('ts-dupe'); });
    }
    if(!btn.querySelector('.ts-lookup-label')){
      btn.innerHTML=
        '<svg class="ts-lookup-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
          '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.2" y2="16.2"/>'+
        '</svg>'+
        '<span class="ts-lookup-label"></span>';
      btn.setAttribute('aria-label','Search');
    }
    btn.querySelector('.ts-lookup-label').textContent='[ SEARCH ]';
    styleLookup(btn);
    wireLookupHover(btn);
    watchThemeToggle(btn);

    posCluster=cluster; posHead=head;
    layoutHeader();
  }

  U.onReady(relocateTrigger);

  /* single resize handler for cluster, toggle and chip */
  var rt=null;
  window.addEventListener('resize',function(){
    clearTimeout(rt);
    rt=setTimeout(function(){
      clearClusterPos();
      layoutHeader();
    },150);
  });
})();

/* ---------- TARRMU PROFILE CHIP ---------- */
(function(){'use strict';
  if(window.__tarrmuProfileChip) return;
  window.__tarrmuProfileChip=true;

  var U=window.Tarrmu;
  var SETTINGS_URL='/profile-settings/';

  function findAccount(){
    var s=document.querySelector('#gh-head, .gh-head, header')||document, c=s.querySelectorAll('a, button');
    for(var i=0;i<c.length;i++){
      if(c[i].closest('#tarrmu-profile')) continue;
      if((c[i].textContent||'').trim().toUpperCase()==='ACCOUNT') return c[i];
    }
    return null;
  }
  function doSignout(){
    try{ if(window.TarrmuAuth&&typeof window.TarrmuAuth.signOut==='function') window.TarrmuAuth.signOut(); }catch(e){}
    fetch('/members/api/session',{method:'DELETE',credentials:'same-origin'})
      .then(function(){ location.href='/'; })
      .catch(function(){ location.href='/#/portal/signout'; location.reload(); });
  }
  function buildChip(profile){
    var root=document.createElement('div'); root.id='tarrmu-profile';
    var m=(window.TarrmuAuth&&window.TarrmuAuth.member)||{};
    var name=profile.display_name||m.name||profile.username||'MEMBER';
    var chip=document.createElement('button'); chip.id='tarrmu-profile-chip'; chip.type='button';
    chip.setAttribute('aria-haspopup','true'); chip.setAttribute('aria-expanded','false');
    var av;
    if(profile.avatar_url&&/^https?:\/\//i.test(profile.avatar_url)){
      av=document.createElement('img'); av.className='tp-avatar'; av.src=U.av(profile.avatar_url, 220); av.alt='';
      av.onerror=function(){ var f=document.createElement('div'); f.className='tp-avatar tp-avatar--initials'; f.textContent=U.initials(name); this.replaceWith(f); };
    }else{
      av=document.createElement('div'); av.className='tp-avatar tp-avatar--initials'; av.textContent=U.initials(name);
    }
    var nm=document.createElement('span'); nm.className='tp-name'; nm.textContent=name;
    var ct=document.createElement('span'); ct.className='tp-caret';
    chip.appendChild(av); chip.appendChild(nm); chip.appendChild(ct);
    var menu=document.createElement('div'); menu.id='tarrmu-profile-menu'; menu.setAttribute('role','menu');
    /* 4_1_43: expanded account menu */
    /* 4_1_295: icons replace the "// " prefix (Lucide-style strokes, MIT) */
    var TP_IC = {"profile": "<circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1\"/>", "games": "<line x1=\"6\" y1=\"11\" x2=\"10\" y2=\"11\"/><line x1=\"8\" y1=\"9\" x2=\"8\" y2=\"13\"/><line x1=\"15\" y1=\"12\" x2=\"15.01\" y2=\"12\"/><line x1=\"18\" y1=\"10\" x2=\"18.01\" y2=\"10\"/><path d=\"M17.32 5H6.68a4 4 0 0 0-3.98 3.59l-.97 8.11A2.5 2.5 0 0 0 6 19.2l3-3.2h6l3 3.2a2.5 2.5 0 0 0 4.27-2.5l-.97-8.11A4 4 0 0 0 17.32 5z\"/>", "physical": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"1\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/>", "reminders": "<path d=\"M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9\"/><path d=\"M13.73 21a2 2 0 0 1-3.46 0\"/>", "wishlist": "<polygon points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"/>", "trophies": "<path d=\"M6 9H4.5a2.5 2.5 0 0 1 0-5H6\"/><path d=\"M18 9h1.5a2.5 2.5 0 0 0 0-5H18\"/><path d=\"M4 22h16\"/><path d=\"M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22\"/><path d=\"M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22\"/><path d=\"M18 2H6v7a6 6 0 0 0 12 0V2Z\"/>", "reviews": "<path d=\"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z\"/><path d=\"M8 9h8\"/><path d=\"M8 13h5\"/>", "quests": "<path d=\"M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z\"/><line x1=\"4\" y1=\"22\" x2=\"4\" y2=\"15\"/>", "settings": "<circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z\"/>", "logout": "<path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\"/><polyline points=\"16 17 21 12 16 7\"/><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\"/>"};
    function tpIcon(k) {
      return '<svg class="tp-mi-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (TP_IC[k] || '') + '</svg>';
    }
    function mi(href, label, icon) {
      var el = document.createElement('a');
      el.className = 'tp-menu-item tp-mi';
      el.setAttribute('role', 'menuitem');
      el.href = href;
      el.innerHTML = tpIcon(icon) + '<span></span>';
      el.lastChild.textContent = label;
      return el;
    }
    var items = [
      mi('/user-profile/', 'PROFILE', 'profile'),
      mi('/game-library/', 'GAME COLLECTION', 'games'),
      mi('/physical-collection/', 'PHYSICAL COLLECTION', 'physical'),
      mi('/reminders/', 'REMINDERS', 'reminders'),
      mi('/wishlist/', 'WISHLIST', 'wishlist'),
      mi('/user-profile/?tab=trophies', 'MY TROPHIES', 'trophies'),
      mi('/user-profile/?tab=reviews', 'MY REVIEWS', 'reviews'),
      mi('/quests/', 'QUESTS', 'quests'),
      mi(SETTINGS_URL, 'PROFILE SETTINGS', 'settings'),
    ];
    items.forEach(function (el) { menu.appendChild(el); });
    var lb = document.createElement('button');
    lb.className = 'tp-menu-item tp-menu-item--logout tp-mi';
    lb.setAttribute('role', 'menuitem');
    lb.type = 'button';
    lb.innerHTML = tpIcon('logout') + '<span>LOGOUT</span>';
    lb.addEventListener('click', doSignout);
    menu.appendChild(lb);
    root.appendChild(chip); root.appendChild(menu);
    chip.addEventListener('click',function(e){ e.stopPropagation(); var o=root.classList.toggle('tp-open'); chip.setAttribute('aria-expanded',o?'true':'false'); });
    document.addEventListener('click',function(e){ if(root.classList.contains('tp-open')&&!root.contains(e.target)){ root.classList.remove('tp-open'); chip.setAttribute('aria-expanded','false'); } });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('tp-open')){ root.classList.remove('tp-open'); chip.setAttribute('aria-expanded','false'); chip.focus(); } });
    return root;
  }

  var mounted=false;
  var CACHE_KEY='tarrmu_chip';   /* {uuid,name,avatar} -- lets the shell paint your real
                                    name + avatar instantly on repeat loads, before the auth
                                    handshake and profile fetch even run. */
  function readCache(){ try{ return JSON.parse(localStorage.getItem(CACHE_KEY)); }catch(e){ return null; } }
  function writeCache(uuid,name,avatar){
    try{ localStorage.setItem(CACHE_KEY,JSON.stringify({uuid:uuid,name:name||'',avatar:avatar||''})); }catch(e){}
  }
  /* was: supabase.from('profiles').select(...).eq('ghost_uuid',uuid).maybeSingle()
     which compiled to exactly this GET. RLS on `profiles` still applies -- the
     minted token is what authorises the row. */
  function mountChip(){
    if(mounted) return;
    var existing=document.getElementById('tarrmu-profile');   /* server-rendered shell, if present */
    var btn=existing?null:findAccount();
    if(!existing&&!btn) return;
    var uuid=window.TarrmuAuth.ghostUuid;
    U.rest('profiles?select=display_name,avatar_url,username&ghost_uuid=eq.'+encodeURIComponent(uuid)+'&limit=1')
      .then(function(rows){
        if(mounted) return;
        mounted=true;
        var p=(rows&&rows[0])||{};
        var chipRoot=buildChip(p);
        chipRoot.classList.add('tp-ready');
        if(existing){ existing.replaceWith(chipRoot); }           /* swap shell for the wired chip, same spot */
        else{ btn.classList.add('tp-hide-account'); btn.parentNode.insertBefore(chipRoot,btn); }
        var m=(window.TarrmuAuth&&window.TarrmuAuth.member)||{};
        writeCache(uuid, p.display_name||m.name||p.username||'', (p.avatar_url&&/^https?:\/\//i.test(p.avatar_url))?p.avatar_url:'');
        if(U.header) U.header.syncChipHeight();
      }).catch(function(err){ console.warn('[tarrmu-profile] profile fetch failed:',err); });
  }
  /* paint the server-rendered shell immediately: cached name + avatar for this member
     if we have them, else initials from the server name. runs on ready, before auth --
     mountChip then refreshes from the live profile. */
  function seedShell(){
    var shell=document.getElementById('tarrmu-profile');
    if(!shell) return;
    var nm=shell.querySelector('.tp-name'), av=shell.querySelector('.tp-avatar--initials');
    var cache=readCache();
    if(cache&&cache.uuid&&cache.uuid===shell.getAttribute('data-uuid')){
      if(cache.name&&nm) nm.textContent=cache.name;
      if(cache.avatar&&/^https?:\/\//i.test(cache.avatar)&&av){
        var img=document.createElement('img'); img.className='tp-avatar'; img.alt=''; img.src=U.av(cache.avatar);
        img.onerror=function(){ var f=document.createElement('div'); f.className='tp-avatar tp-avatar--initials'; f.textContent=U.initials((nm&&nm.textContent.trim())||'?'); this.replaceWith(f); };
        av.replaceWith(img);
        return;
      }
    }
    if(av&&!av.textContent.trim()&&nm){
      var n=nm.textContent.trim();
      if(n) av.textContent=U.initials(n);
    }
  }
  function init(){
    seedShell();
    U.whenAuthReady(10000).then(function(){
      if(window.TarrmuAuth&&window.TarrmuAuth.ghostUuid) mountChip();
    });
  }
  U.onReady(init);
  window.addEventListener('pageshow',function(e){ if(e.persisted&&!mounted) init(); });
})();

/* ---------- TARRMU relocate More Like This + TOC ---------- */
(function(){'use strict';
  if(!document.body.classList.contains('post-template')) return;

  var RAIL_MAX = 340, RAIL_MIN = 230, RAIL_GAP = 36, PAGE_EDGE = 24;

  /* Reviews / Retrospectives / Analysis carry a server-rendered .game-info-wrap
     (or a review verdict badge). Those keep the existing layout, where the rail
     is lifted into the game-details row. A post WITHOUT one (News / Indie Hour /
     Thinking Out Loud) instead gets the wide feature-image header, with the rail
     floated into the gutter to the right of the image. .game-info-wrap is in the
     DOM at parse time, so adding the class here (blocking, end-of-body) lands it
     before first paint and avoids a narrow->wide reflow. */
  function hasGameDetails(){
    return !!document.querySelector('.gh-content .game-info-wrap, .game-info-wrap, .review-badge-card, .gh-content [data-toc], .gh-content [class*="game-details"]');
  }
  if(!hasGameDetails() && document.querySelector('#tarmu-post-header .tarmu-header-side')){
    document.body.classList.add('tarmu-wide-hero');
  }

  /* NEWS header: float the rail into the right gutter, top-aligned to the feature
     image. If the gutter is narrower than RAIL_MIN, drop the rail below the image
     as a centred, image-width strip. Measured, so it is correct at every width. */
  function placeNewsRail(){
    var header = document.querySelector('#tarmu-post-header');
    if(!header) return;
    var fig  = header.querySelector('.gh-article-image');
    var rail = header.querySelector('.tarmu-header-side');
    if(!fig || !rail) return;
    var hr = header.getBoundingClientRect(), fr = fig.getBoundingClientRect();
    if(!fr.width){ return; }                     /* image not laid out yet */
    var avail = Math.floor((hr.right - fr.right) - RAIL_GAP - PAGE_EDGE);
    if(avail >= RAIL_MIN){
      rail.style.top   = Math.round(fr.top   - hr.top)  + 'px';
      rail.style.left  = Math.round(fr.right - hr.left + RAIL_GAP) + 'px';
      rail.style.width = Math.min(RAIL_MAX, avail) + 'px';
      rail.classList.add('tarmu-rail-placed');
      rail.classList.remove('tarmu-rail-below');
    } else {
      rail.classList.remove('tarmu-rail-placed');
      rail.classList.add('tarmu-rail-below');
      rail.style.top = ''; rail.style.left = ''; rail.style.width = '';
    }
  }

  function run(){
    var gd  = document.querySelector('.gh-content .game-info-wrap')||document.querySelector('.game-info-wrap');
    var mlt = document.querySelector('#tarmu-post-header .tarmu-header-side, .tarmu-header-side');
    if(!mlt) return;
    if(!gd){
      /* no game details -> wide-hero news header. If a review marker turns up
         late (rare, e.g. a JS-built badge), undo the class and bail. */
      if(hasGameDetails()){ document.body.classList.remove('tarmu-wide-hero'); return; }
      document.body.classList.add('tarmu-wide-hero');
      placeNewsRail();
      return;
    }
    var row=gd.closest('.tarmu-gd-row');
    if(!row){
      row=document.createElement('div'); row.className='tarmu-gd-row';
      var main=document.createElement('div'); main.className='tarmu-gd-main';
      gd.parentNode.insertBefore(row,gd);
      row.appendChild(main); main.appendChild(gd);
    }
    var main2=row.querySelector('.tarmu-gd-main');
    var toc=document.querySelector('.gh-content .toc-wrap');
    if(toc&&main2&&!main2.contains(toc)) main2.appendChild(toc);
    mlt.classList.add('tarmu-mlt-moved');
    if(mlt.parentNode!==row) row.appendChild(mlt);
    syncBand(row);
  }

  /* The row cannot be aligned to the feature image by CSS arithmetic, because
     the two live in different boxes: #tarmu-post-header sits 155px right of
     page centre at 1922px, and the feature image is grid-column:wide inside a
     1096px .tarmu-header-main, so it renders at 1000px, not 1096. Any formula
     that reproduces one from the other is guessing at both.

     So measure it. These three custom properties are the only thing the CSS
     needs, and they re-derive on resize, which makes the layout correct at
     every viewport rather than at the one it was tuned on.

       --tarmu-band-x  left edge of the feature image, relative to .gh-content
       --tarmu-band-w  its width
       --tarmu-rail-w  how wide the rail can be in the space left to the right
                       of the band, clamped to 340px

     .tarmu-rail-out is added only when at least RAIL_MIN of room survives.
     Below that the rail stays inside the band, because a 160px rail beside a
     1000px band reads as a mistake rather than a layout. */
  function syncBand(row){
    row = row || document.querySelector('.gh-content .tarmu-gd-row');
    if(!row || !row.parentNode) return;
    var fi = document.querySelector('#tarmu-post-header .gh-article-image');
    var host = row.parentNode.getBoundingClientRect();
    if(!fi){ row.classList.remove('tarmu-rail-out'); return; }

    var f = fi.getBoundingClientRect();
    if(!f.width){ return; }                     /* image not laid out yet */

    row.style.setProperty('--tarmu-band-x', Math.round(f.left - host.left) + 'px');
    row.style.setProperty('--tarmu-band-w', Math.round(f.width) + 'px');

    var free = (host.right - f.right) - PAGE_EDGE - RAIL_GAP;
    var railW = Math.min(RAIL_MAX, Math.floor(free));
    if(railW >= RAIL_MIN){
      row.style.setProperty('--tarmu-rail-w', railW + 'px');
      row.classList.add('tarmu-rail-out');
    } else {
      row.style.removeProperty('--tarmu-rail-w');
      row.classList.remove('tarmu-rail-out');
    }
  }

  /* News posts reflow the gutter rail; review posts re-measure the band. */
  function reflow(){
    if(document.body.classList.contains('tarmu-wide-hero')) placeNewsRail();
    else syncBand();
  }

  var _bandT = null;
  window.addEventListener('resize', function(){
    clearTimeout(_bandT);
    _bandT = setTimeout(reflow, 120);
  });
  /* the feature image can change the band's height, and therefore nothing, but
     it can change its WIDTH once it decodes and srcset settles */
  window.addEventListener('load', reflow);

  window.Tarrmu.onReady(run);
  window.addEventListener('pageshow',function(e){ if(e.persisted) run(); });
})();

/* ---------- TARRMU NOTIFICATION BELL ---------- */
(function(){'use strict';
  if(window.__tarrmuBell) return;
  window.__tarrmuBell=true;

  var U=window.Tarrmu;
  /* game pages resolve by igdb_id (same pattern as the release calendar).
     Falls back to the legacy slug link only while the RPC doesn't yet
     return igdb_id, so nothing breaks between deploys. */
  function gameHref(it){
    /* Event notifications link to /event/?id=<event_id> from payload */
    if(it && it.kind === 'event' && it.payload && it.payload.event_id){
      return '/event/?id=' + encodeURIComponent(it.payload.event_id);
    }
    if(it&&it.igdb_id!=null&&isFinite(Number(it.igdb_id))) return '/game/?igdb='+encodeURIComponent(Number(it.igdb_id));
    return '/game/?slug='+encodeURIComponent((it&&it.tag_slug)||'');
  }

  /* a small cover is plenty at 40px -- matches the site's t_cover_small_2x rule.
     Event art arrives as IGDB 1080p/screenshot or YouTube maxres URLs, so
     downscale those too rather than pulling a full-size image for a thumb. */
  function thumb(u){
    if (typeof u !== 'string') return u;
    return u
      .replace('/t_cover_big/','/t_cover_small_2x/')
      .replace('/t_1080p/','/t_cover_small_2x/')
      .replace('/t_screenshot_big/','/t_screenshot_med/')
      .replace('/t_screenshot_huge/','/t_screenshot_med/')
      .replace('/maxresdefault.jpg','/mqdefault.jpg');
  }

    /* Price-drop rows (kind 'pricedrop') render a one-line deal summary. */
  function storeLabel(slug){ return ({ steam:'Steam', epic:'Epic', gog:'GOG', xbox:'Xbox',
    playstation:'PlayStation', nintendo:'Nintendo', microsoft_store:'MS Store', apple:'App Store' })[slug] || slug || 'a store'; }
  function priceSub(it){
    var s='Price drop';
    if(it.sale_price!=null){
      s+=' — '+window.Tarrmu.money(it.sale_price, it.currency||'AUD', !!it.approx)+' at '+storeLabel(it.store_slug);
      if(it.discount_pct) s+=' ('+Number(it.discount_pct)+'% off)';
    }
    return s;
  }

  var Bell={
    root:null, listEl:null, countEl:null, items:[], loaded:false,

    mount:function(){
      if(this.root) return this.root;
      var r=document.getElementById('tarrmu-bell');   /* server-rendered shell */
      if(!r) return null;
      this.root=r;
      this.listEl=r.querySelector('.tb-list');
      this.countEl=r.querySelector('#tarrmu-bell-count');
      var btn=r.querySelector('#tarrmu-bell-btn'), self=this;
      btn.addEventListener('click',function(e){ e.stopPropagation(); self.toggle(); });
      document.addEventListener('click',function(e){ if(self.root&&!self.root.contains(e.target)) self.close(); });
      r.querySelector('#tarrmu-bell-menu').addEventListener('click',function(e){ e.stopPropagation(); });
      /* match height to the theme toggle, the same source the chip syncs to */
      var tog=document.getElementById('tarrmuTheme');
      if(tog){ var h=tog.offsetHeight; if(h) btn.style.setProperty('height',h+'px','important'); }
      return r;
    },

    filter:'all',
  ensureFilters:function(){
    if(this.fbar||!this.root) return;
    var menu=this.root.querySelector('#tarrmu-bell-menu'); if(!menu) return;
    var bar=document.createElement('div'); bar.className='tb-filters';
    var self=this;
    [['all','All'],['price','💲 Price alerts'],['release','Releases'],['social','Social']].forEach(function(f){
      var b=document.createElement('button'); b.type='button'; b.className='tb-f'; b.setAttribute('data-f',f[0]);
      b.innerHTML='<span></span><em></em>'; b.firstChild.textContent=f[1];
      b.addEventListener('click',function(e){ e.stopPropagation(); self.filter=f[0]; self.render(); });
      bar.appendChild(b);
    });
    var head=menu.querySelector('.tb-head');
    if(head&&head.nextSibling) menu.insertBefore(bar, head.nextSibling); else menu.insertBefore(bar, menu.firstChild);
    var pl=document.createElement('a'); pl.className='tb-all tb-palog'; pl.href='/wishlist/?tab=alerts';
    pl.textContent='PRICE ALERT LOG \u2192 WISHLIST';
    var all=menu.querySelector('.tb-all'); if(all) menu.insertBefore(pl, all); else menu.appendChild(pl);
    this.fbar=bar; this.palog=pl;
  },
  paintFilters:function(){
    if(!this.fbar) return;
    var items=this.items, self=this;
    var cnt={ price:items.filter(function(x){ return x._kind==='pricedrop'&&!x.read_at; }).length };
    this.fbar.querySelectorAll('.tb-f').forEach(function(b){
      var f=b.getAttribute('data-f'); b.classList.toggle('on', f===(self.filter||'all'));
      var em=b.querySelector('em'); em.textContent=(f==='price'&&cnt.price)?String(cnt.price):'';
    });
    if(this.palog) this.palog.style.display=(this.filter==='price'||items.some(function(x){ return x._kind==='pricedrop'; }))?'':'none';
  },

  toggle:function(){ if(!this.root) return; var o=this.root.classList.toggle('tb-open'); if(o) this.markRead(); },
    close:function(){ if(this.root) this.root.classList.remove('tb-open'); },

    unreadCount:function(){ return this.items.filter(function(x){ return !x.read_at; }).length; },

    /* on open: mark every unread release read server-side, then clear dots + badge.
       Follow-post notifications get their own read marker RPC. */
    markRead:function(){
      if(!this.unreadCount()) return;
      U.rpc('mark_bell_read',{}).catch(function(e){ console.warn('[bell] mark read failed',e); });
      if(this.items.some(function(x){ return x._kind!=='release'; })){
        U.rpc('mark_follow_notifications_read',{}).catch(function(e){ console.warn('[bell] follow mark read failed',e); });
      }
      if(this.items.some(function(x){ return x._kind==='pricedrop' && !x.read_at; })){
        U.rpc('mark_price_alerts_read',{}).catch(function(e){ console.warn('[bell] pricedrop mark read failed',e); });
      }
      this.items.forEach(function(x){ if(!x.read_at) x.read_at=true; if(x._el) x._el.classList.remove('tb-unread'); });
      if(this.root) this.root.classList.remove('tb-has-unread');
      if(this.countEl) this.countEl.textContent='0';
    },

    render:function(){
      if(!this.listEl) return;
      var self=this, unread=0;
      if(!this.items.length){
        this.listEl.innerHTML='<div class="tb-empty">Nothing tracked yet</div>';
        if(this.root) this.root.classList.remove('tb-has-unread');
        if(this.countEl) this.countEl.textContent='0';
        return;
      }
      this.listEl.textContent='';
      /* Dropdown shows the newest 10; the rest live on the /notifications/
         history page (linked from the tb-all footer). Unread count still
         covers the full set so the badge never under-reports. */
      /* 4_1_243: filter chips (All / Price alerts / Releases / Social) */
      this.ensureFilters();
      var flt = this.filter || 'all';
      var pool = this.items.filter(function(x){
        if(flt==='price') return x._kind==='pricedrop';
        if(flt==='release') return x._kind==='release';
        if(flt==='social') return x._kind!=='pricedrop' && x._kind!=='release';
        return true;
      });
      this.paintFilters();
      if(!pool.length){ this.listEl.innerHTML='<div class="tb-empty">Nothing here yet</div>'; }
      var shown = pool.slice(0, 10);
      var unreadTotal = this.items.filter(function(x){ return !x.read_at; }).length;
      shown.forEach(function(it){
        var isNew=!it.read_at; if(isNew) unread++;
        var a=document.createElement('a');
        a.className='tb-item'+(isNew?' tb-unread':'');
        /* FOLLOW-EVENT items: "X has followed you" from
           get_follow_event_notifications. Shows the follower's avatar (or a
           "//" tile) and links to their profile. */
        if(it._kind==='followevent'){
          var eu=String(it.username||it.follower_uuid||'');
          a.href='/user-profile/?u='+encodeURIComponent(eu);
          var ev=U.av(it.avatar_url);
          if(ev){
            var ei=document.createElement('img');
            ei.className='tb-cov';
            ei.alt='';
            ei.loading='lazy';
            ei.decoding='async';
            ei.addEventListener('error',function(){
              var d=document.createElement('div');
              d.className='tb-cov tb-cov-topic';
              d.textContent='//';
              ei.replaceWith(d);
            });
            ei.src=ev;
            a.appendChild(ei);
          }else{
            var ed=document.createElement('div');
            ed.className='tb-cov tb-cov-topic';
            ed.textContent='//';
            a.appendChild(ed);
          }
          var et=document.createElement('div'); et.className='tb-txt';
          var en=document.createElement('div'); en.className='tb-name';
          en.textContent=(it.display_name||'member')+' followed you';
          en.title=it.display_name||'';
          var es=document.createElement('div'); es.className='tb-sub';
          es.textContent=U.fmtDate(it.created_at);
          et.appendChild(en); et.appendChild(es);
          a.appendChild(et);
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        /* FOLLOW-POST items: topic row from get_follow_notifications.
           Links to /discussion/?topic=<id>; a "//" tile stands in for art. */
        if(it._kind==='follow'){
          var p=String(it.url_path||'');
          a.href=(p.charAt(0)==='/'&&p.charAt(1)!=='/')?p:'#';
          var fc=document.createElement('div');
          fc.className='tb-cov tb-cov-topic';
          fc.textContent='//';
          a.appendChild(fc);
          var ft=document.createElement('div'); ft.className='tb-txt';
          var fn=document.createElement('div'); fn.className='tb-name';
          fn.textContent=it.title||'New topic';
          fn.title=it.title||'';
          var fs=document.createElement('div'); fs.className='tb-sub';
          fs.textContent='TOPIC \u00b7 '+(it.author_name||'member')+(it.game_name?(' \u00b7 '+it.game_name):'');
          ft.appendChild(fn); ft.appendChild(fs);
          a.appendChild(ft);
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        /* REVIEW items: "X posted a review" from get_review_notifications.
           Links to the game's reviews tab. */
        if(it._kind==='review'){
          a.href=it.url_path||('#/game/?igdb='+(it.igdb_id||'')+'&tab=reviews');
          var rc=document.createElement('div');
          rc.className='tb-cov tb-cov-topic';
          rc.textContent='\u2605';
          a.appendChild(rc);
          var rt=document.createElement('div'); rt.className='tb-txt';
          var rn=document.createElement('div'); rn.className='tb-name';
          rn.textContent=(it.author_name||'member')+' posted a review';
          rn.title=it.title||'';
          var rs=document.createElement('div'); rs.className='tb-sub';
          rs.textContent='REVIEW \u00b7 '+(it.game_name||'');
          rt.appendChild(rn); rt.appendChild(rs);
          a.appendChild(rt);
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        /* MENTION items: "X mentioned you" from get_mention_notifications.
           Actor avatar (or an "@" tile) and a link to the thread or post. */
        /* BADGE items: "Badge unlocked" with the badge art, links to the Badges tab */
        if(it._kind==='badge'){
          a.href='/user-profile/?tab=badges';
          var bi=document.createElement('img');
          bi.className='tb-cov tb-cov-badge'; bi.alt=''; bi.loading='lazy'; bi.decoding='async';
          bi.style.objectFit='contain';
          bi.src='/assets/images/badges/'+String(it.image||'').replace(/[^0-9a-z.\-]/gi,'');
          a.appendChild(bi);
          var bt=document.createElement('div'); bt.className='tb-txt';
          var bn=document.createElement('div'); bn.className='tb-name';
          bn.textContent='Badge unlocked: '+(it.name||'');
          bn.title=it.name||'';
          var bs=document.createElement('div'); bs.className='tb-sub';
          bs.textContent='BADGE \u00b7 '+U.fmtDate(it.created_at);
          bt.appendChild(bn); bt.appendChild(bs);
          a.appendChild(bt);
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        if(it._kind==='pricedrop'){
          a.href=gameHref(it);
          var pc=U.safeUrl(thumb(it.game_cover));
          a.innerHTML=(pc?'<img class="tb-cov" alt="" loading="lazy" decoding="async">':'<div class="tb-cov"></div>')+
            '<div class="tb-txt"><div class="tb-name"></div><div class="tb-sub"></div></div>';
          a.querySelector('.tb-name').textContent=it.game_name||'Price drop';
          a.querySelector('.tb-sub').textContent=priceSub(it);
          if(pc) a.querySelector('img.tb-cov').src=pc;
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        if(it._kind==='mention'){
          var mp=String(it.url_path||'');
          a.href=(mp.charAt(0)==='/'&&mp.charAt(1)!=='/')?mp:'#';
          var mv=U.av(it.actor_avatar);
          if(mv){
            var mi=document.createElement('img');
            mi.className='tb-cov'; mi.alt=''; mi.loading='lazy'; mi.decoding='async';
            mi.addEventListener('error',function(){
              var d=document.createElement('div'); d.className='tb-cov tb-cov-topic'; d.textContent='@'; mi.replaceWith(d);
            });
            mi.src=mv; a.appendChild(mi);
          }else{
            var md=document.createElement('div'); md.className='tb-cov tb-cov-topic'; md.textContent='@'; a.appendChild(md);
          }
          var mt=document.createElement('div'); mt.className='tb-txt';
          var mn=document.createElement('div'); mn.className='tb-name';
          mn.textContent=(it.actor_name||'Someone')+' mentioned you';
          mn.title=it.actor_name||'';
          var ms=document.createElement('div'); ms.className='tb-sub';
          ms.textContent=(it.reply_id?'reply in ':'')+(it.title||'a discussion');
          ms.title=it.title||'';
          mt.appendChild(mn); mt.appendChild(ms);
          a.appendChild(mt);
          it._el=a;
          self.listEl.appendChild(a);
          return;
        }
        a.href=gameHref(it);
        var cov=U.safeUrl(thumb(it.game_cover));
        a.innerHTML=(cov?'<img class="tb-cov" alt="" loading="lazy" decoding="async">':'<div class="tb-cov"></div>')+
          '<div class="tb-txt"><div class="tb-name"></div><div class="tb-sub"></div></div>';
        a.querySelector('.tb-name').textContent=it.game_name||'New release';
        a.querySelector('.tb-sub').textContent='Out '+U.fmtDate(it.release_date);
        if(cov) a.querySelector('img.tb-cov').src=cov;
        it._el=a;
        self.listEl.appendChild(a);
      });
      this.countEl.textContent=unreadTotal>9?'9+':String(unreadTotal);
      this.root.classList.toggle('tb-has-unread',unreadTotal>0);
    },

    load:function(){
      if(this.loaded) return;
      var r=this.mount(); if(!r) return;
      var self=this;
      /* Release + follow-post notifications load in parallel and merge into
         one timeline. Both RPCs are authenticated-only, so this only runs once
         auth resolves. Either source failing (e.g. the follow SQL not deployed
         yet) degrades to the other — the bell never goes blank on one source. */
      Promise.all([
        U.rpc('get_bell_notifications',{ p_limit:10 }).catch(function(e){ console.warn('[bell] release load failed',e); return []; }),
        U.rpc('get_follow_notifications',{ p_limit:5 }).catch(function(e){ console.warn('[bell] follow load failed',e); return []; }),
        U.rpc('get_follow_event_notifications',{ p_limit:5 }).catch(function(e){ console.warn('[bell] follow-event load failed',e); return []; }),
        U.rpc('get_mention_notifications',{ p_limit:5 }).catch(function(e){ console.warn('[bell] mention load failed',e); return []; }),
        U.rpc('get_price_drop_notifications',{ p_limit:10 }).catch(function(e){ console.warn('[bell] pricedrop load failed',e); return []; }),
        U.rpc('get_review_notifications',{ p_limit:5 }).catch(function(e){ console.warn('[bell] review load failed',e); return []; }),
        U.rpc('get_badge_notifications',{ p_limit:5 }).catch(function(e){ console.warn('[bell] badge load failed',e); return []; })
      ]).then(function(parts){
        self.loaded=true;
        var release=parts[0]||[], follow=parts[1]||[], events=parts[2]||[], mentions=parts[3]||[], price=parts[4]||[], reviews=parts[5]||[];
        release.forEach(function(it){ it._kind='release'; });
        /* server says whether each row is newer than the last bell open; map
           is_new onto the client's read_at so the unread dot and badge only
           count genuinely new items, and opening the bell clears them */
        follow.forEach(function(it){
          it._kind='follow';
          if(!it.is_new) it.read_at=true;
        });
        events.forEach(function(it){
          it._kind='followevent';
          if(!it.is_new) it.read_at=true;
        });
        /* mentions ride the SAME notification_reads cursor as follow items,
           so is_new is already server-computed and markRead's existing
           mark_follow_notifications_read call clears them too */
        mentions.forEach(function(it){
          it._kind='mention';
          if(!it.is_new) it.read_at=true;
        });
        price.forEach(function(it){
          it._kind='pricedrop';
          if(!it.is_new) it.read_at=true;
        });
        reviews.forEach(function(it){
          it._kind='review';
          if(!it.is_new) it.read_at=true;
        });
        /* badge unlocks ride the same notification_reads cursor */
        var badges=parts[6]||[];
        badges.forEach(function(it){
          it._kind='badge';
          if(!it.is_new) it.read_at=true;
        });
        self.items=release.concat(follow, events, mentions, price, reviews, badges).sort(function(a,b){
          var ka=a._kind==='release'?(a.release_date||''):(a.created_at||'');
          var kb=b._kind==='release'?(b.release_date||''):(b.created_at||'');
          return (kb>ka?1:(kb<ka?-1:0));
        });
        self.render();
      });
    }
  };

  window.TarrmuBell=Bell;

  function boot(){
    var r=Bell.mount(); if(!r) return;
    if(window.TarrmuAuth&&window.TarrmuAuth.ghostUuid){ Bell.load(); }
    else if(Bell.listEl){ Bell.listEl.innerHTML='<div class="tb-empty">Nothing tracked yet</div>'; }
  }
  U.onReady(function(){
    Bell.mount();                       /* wire the shell immediately */
    U.whenAuthReady(10000).then(boot);  /* load once the auth bridge resolves */
  });
  window.addEventListener('pageshow',function(e){ if(e.persisted){ Bell.loaded=false; boot(); } });
})();

/* ---------- TARRMU HOME HUB (homepage Community Hub widgets) ----------
   Fills the three #tarrmuHub widgets rendered by partials/tarrmu/hub.hbs.
   Desktop-only by design: bails when the hub element is absent OR the
   viewport is under 1280px, so mobile never pays for these fetches.

   Track A semantics: all three fetches fire immediately at script parse
   time via the anon-capable helpers; nothing here waits on TarrmuAuth.

   Data contracts (verified against the live DB before this was written):
     games ......... anon SELECT true; columns game_name, game_cover,
                     release_date (date, nullable), platforms (text[])
     goty_leaderboard() ... SECURITY DEFINER, anon exec; returns games
                     rows plus votes + rank
     goty_total_votes() ... SECURITY DEFINER, anon exec; returns bigint
     community_spotlight(p_limit int) ... SECURITY DEFINER, anon exec;
                     returns rank, display_name, avatar_url, xp
                     (must exist -- created with the 2.1.8 delivery SQL)

   All row content is inserted via textContent; avatar/cover URLs pass
   through Tarrmu.safeUrl. IGDB covers arrive as t_cover_big and are
   swapped to t_cover_small for the 40px slots. */
(function(){'use strict';
  var root=document.getElementById('tarrmuHub');
  if(!root) return;
  if(!window.matchMedia||!window.matchMedia('(min-width:1280px)').matches) return;

  var U=window.Tarrmu, XP=window.TarrmuXP;
  if(!U) return;

  var MONTHS=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var PLAT={
    'PC (Microsoft Windows)':'PC',
    'PlayStation 5':'PS5',
    'PlayStation 4':'PS4',
    'PlayStation VR2':'PSVR2',
    'Xbox Series X|S':'XSX',
    'Xbox One':'XB1',
    'Nintendo Switch 2':'NS2',
    'Nintendo Switch':'NSW',
    'Mac':'MAC','macOS':'MAC','Linux':'LNX','iOS':'IOS','Android':'AND'
  };

  function el(tag,cls,txt){
    var e=document.createElement(tag);
    if(cls) e.className=cls;
    if(txt!=null) e.textContent=txt;
    return e;
  }
  function widgetBody(id){
    var w=document.getElementById(id);
    return w?w.querySelector('.hubw-body'):null;
  }
  function fail(id){
    var b=widgetBody(id);
    if(b){ b.textContent=''; b.appendChild(el('div','hub-empty','// UNAVAILABLE')); }
  }
  function leadImg(url,cls,alt){
    var u=U.av(url);   /* resize Supabase-stored leader avatars */
    if(u){
      var i=document.createElement('img');
      i.className=cls;
      i.src=u.replace('t_cover_big','t_cover_small');
      i.alt='';
      i.loading='lazy';
      i.decoding='async';
      return i;
    }
    return el('div',cls+' hub-ini',U.initials(alt||'?'));
  }
  function shortDate(iso){
    var d=new Date(iso+'T00:00:00');
    if(isNaN(d)) return '';
    return (d.getDate()<10?'0':'')+d.getDate()+' '+MONTHS[d.getMonth()];
  }
  function platLine(a){
    if(!Array.isArray(a)||!a.length) return '';
    return a.map(function(p){
      p=String(p);
      return PLAT[p]||p.replace(/\(.*\)/,'').trim().slice(0,4).toUpperCase();
    }).join(' / ');
  }
  function pad2(n){ n=Number(n); return (n<10?'0':'')+n; }
  function row(lead,name,sub,val,rank){
    var r=el('div','hub-row');
    /* rank sits LEFT of the image with the divider between them
       (spotlight layout); rows without a rank just start at the image */
    if(rank!=null) r.appendChild(el('div','hub-rank',pad2(rank)));
    if(lead) r.appendChild(lead);
    var info=el('div','hub-info');
    info.appendChild(el('div','hub-name',name));
    if(sub) info.appendChild(el('div','hub-sub',sub));
    r.appendChild(info);
    if(val) r.appendChild(el('div','hub-val',val));
    return r;
  }

  /* IGDB has no cover art for a large share of DLC. Rather than an initials
     tile, borrow the base game's cover -- dimmed via .hub-cover-inherited so
     it reads as "related to" rather than "is". Runs after first paint; any
     failure just leaves the initials tile in place. */
  function fillParentCovers(pending){
    var ids=[];
    pending.forEach(function(p){ if(ids.indexOf(p.pid)<0) ids.push(p.pid); });
    if(!ids.length) return;
    U.rest('games?select=igdb_id,game_cover&igdb_id=in.('+ids.join(',')+')')
      .then(function(rows){
        var byId={};
        (rows||[]).forEach(function(r){ if(r.game_cover) byId[Number(r.igdb_id)]=r.game_cover; });
        pending.forEach(function(p){
          var src=byId[p.pid];
          if(!src||!p.lead.parentNode) return;
          var img=leadImg(src,'hub-cover hub-cover-inherited',p.name);
          if(img.tagName!=='IMG') return;          /* safeUrl rejected it */
          p.lead.parentNode.replaceChild(img,p.lead);
          p.lead=img;
        });
      })
      .catch(function(){ /* initials tile stays -- decorative only */ });
  }

  /* 1 -- UPCOMING_RELEASES: dated future releases only (release_date is
     nullable; fuzzy "Q4 2026" style games are excluded on purpose).

     dlc_hidden=is.false drops cosmetic / single-track / seasonal-event /
     outfit-variant DLC. The column is NOT NULL DEFAULT false, so this
     predicate never affects games.

     The secondary game_name sort is what makes this panel agree with the
     release calendar: several titles share a release date, and without an
     explicit tiebreak Postgres returns those ties in arbitrary order, so a
     5-row window could pick different rows than the calendar's full list.

     HUB_INCLUDE_DLC=false narrows the panel to games only. Worth considering:
     this is a 5-slot homepage widget, and substantive DLC still competes with
     headline releases for those slots. */
  var HUB_INCLUDE_DLC=true;
  var now=new Date();
  var today=now.getFullYear()+'-'+pad2(now.getMonth()+1)+'-'+pad2(now.getDate());
  U.rest('games?select=game_name,game_cover,release_date,platforms,is_dlc,parent_igdb_id'
        +'&release_date=gte.'+today
        +'&dlc_hidden=is.false'
        +(HUB_INCLUDE_DLC?'':'&is_dlc=is.false')
        +'&order=release_date.asc,game_name.asc&limit=5')
    .then(function(rows){
      var b=widgetBody('hubReleases'); if(!b) return;
      if(!rows||!rows.length){ fail('hubReleases'); return; }
      b.textContent='';
      var needParent=[];
      rows.forEach(function(g){
        var lead=leadImg(g.game_cover,'hub-cover',g.game_name);
        if(!g.game_cover&&g.is_dlc&&g.parent_igdb_id!=null){
          needParent.push({ lead:lead, pid:Number(g.parent_igdb_id), name:g.game_name });
        }
        b.appendChild(row(
          lead,
          g.game_name||'',
          platLine(g.platforms),
          g.release_date?shortDate(g.release_date):''
        ));
      });
      fillParentCovers(needParent);
    })
    .catch(function(){ fail('hubReleases'); });

  /* 2 -- GOTY_STANDINGS: top 3 by rank + total vote count in the footer. */
  U.rpc('goty_leaderboard')
    .then(function(rows){
      var b=widgetBody('hubGoty'); if(!b) return;
      if(!rows||!rows.length){ fail('hubGoty'); return; }
      rows=rows.slice().sort(function(a,c){
        return (a.rank!=null?a.rank:9e9)-(c.rank!=null?c.rank:9e9);
      }).slice(0,3);
      b.textContent='';
      rows.forEach(function(g){
        var name=(g.rank!=null?pad2(g.rank)+'  ':'')+(g.game_name||'');
        var votes=(g.votes!=null)?(g.votes+(Number(g.votes)===1?' VOTE':' VOTES')):'';
        b.appendChild(row(
          leadImg(g.game_cover,'hub-cover',g.game_name),
          name,'',votes
        ));
      });
    })
    .catch(function(){ fail('hubGoty'); });

  U.rpc('goty_total_votes')
    .then(function(n){
      var s=document.getElementById('hubGotyVotes');
      if(s&&n!=null&&n!=='') s.textContent='// '+n+' TOTAL VOTES';
    })
    .catch(function(){ /* footer count is decorative; fail silent */ });

  /* 3 -- 2026_COMMUNITY_SPOTLIGHT: rank title derived client-side from the
     canonical TarrmuXP ladder so it can never drift from the site rules. */
  U.rpc('community_spotlight',{p_limit:5})
    .then(function(rows){
      var b=widgetBody('hubSpotlight'); if(!b) return;
      if(!rows||!rows.length){ fail('hubSpotlight'); return; }
      b.textContent='';
      rows.forEach(function(m){
        var title=XP?XP.rankFromLevel(XP.levelFromXp(m.xp)):'';
        var xp=(m.xp!=null)?(Number(m.xp).toLocaleString()+' XP'):'';
        b.appendChild(row(
          leadImg(m.avatar_url,'hub-pfp',m.display_name),
          m.display_name||'',title,xp,m.rank
        ));
      });
    })
    .catch(function(){ fail('hubSpotlight'); });
})();

/* ---------- TARRMU QUEST XP SYNC (global) ----------
   Runs sync_member_quests() once per page load for logged-in members,
   so completed-quest XP is awarded no matter what page they land on --
   not only on /quests/. The RPC is idempotent (on conflict do nothing +
   if-found guard), so calling it everywhere never double-awards.
   On a fresh award it re-reads the authoritative total and fires
   `tarrmu-xp-synced` so any XP display can update without a reload. */
(function(){'use strict';
  var U=window.Tarrmu;
  if(!U||window.__tarrmuXpSyncBooted) return;
  window.__tarrmuXpSyncBooted=true;

  /* Optional throttle: min ms between syncs per browser session.
     0 = sync on every page load (safe; idempotent). Raise to e.g.
     120000 to sync at most once every 2 min if you want fewer calls. */
  var SYNC_MIN_INTERVAL_MS=0;
  var THROTTLE_KEY='tarrmu_xp_sync_at';

  function throttled(){
    if(SYNC_MIN_INTERVAL_MS<=0) return false;
    try{
      var last=parseInt(sessionStorage.getItem(THROTTLE_KEY)||'0',10);
      if(Date.now()-last<SYNC_MIN_INTERVAL_MS) return true;
    }catch(e){}
    return false;
  }
  function stamp(){ try{ sessionStorage.setItem(THROTTLE_KEY,String(Date.now())); }catch(e){} }

  function run(){
    var A=window.TarrmuAuth;
    if(!A||!A.ready||!A.ghostUuid) return;   /* members only */
    if(throttled()) return;
    stamp();

    U.rpc('sync_member_quests',{})
      .then(function(rows){
        if(!Array.isArray(rows)) return;
        var justDone=rows.filter(function(r){ return r&&r.just_completed; });
        if(!justDone.length) return;         /* nothing new -> no re-read */

        /* A quest just completed this load: pull the authoritative new
           total and broadcast it so any XP display can refresh live. */
        var uuid=A.ghostUuid;
        U.rest('profiles?select=xp&ghost_uuid=eq.'+encodeURIComponent(uuid)+'&limit=1')
          .then(function(p){
            var xp=(p&&p[0]&&p[0].xp!=null)?Number(p[0].xp):null;
            try{ if(A.member) A.member.xp=xp; }catch(e){}
            window.dispatchEvent(new CustomEvent('tarrmu-xp-synced',{
              detail:{ xp:xp, completed:justDone }
            }));
          })
          .catch(function(){
            /* still broadcast completions even if the re-read fails */
            window.dispatchEvent(new CustomEvent('tarrmu-xp-synced',{
              detail:{ xp:null, completed:justDone }
            }));
          });
      })
      .catch(function(err){ /* silent: sync is best-effort, never blocks a page */ });
  }

  U.whenAuthReady(10000).then(run);
})();

/* ---------- TARRMU HUB :: personalise "View community quests" link ----------
   Rewrites the homepage Community Hub header link to the signed-in member's
   own quest slug: /quests/?u=<username>. Logged-out visitors keep the plain
   /quests/ link (which shows the members-only prompt on that page).

   NOTE ON BEHAVIOUR: plain /quests/ is the *synced owner view* -- it re-runs
   sync_member_quests() and fires the completion celebration. /quests/?u=<h>
   is the READ-ONLY public view (no toast/pop). XP itself is unaffected either
   way, since the global XP-sync module above already awards on every load.

   Set PERSONALISE=false to leave this link as plain /quests/ (recommended:
   reserve ?u= for links that point at OTHER members). */
(function(){'use strict';
  var PERSONALISE=true;                    /* false -> leave link as /quests/ */
  if(!PERSONALISE) return;

  var U=window.Tarrmu;
  if(!U||typeof U.whenAuthReady!=='function') return;

  var link=document.querySelector('#tarrmuHub .shead a.more');
  if(!link) return;                        /* not the homepage / hub absent */

  var base=link.getAttribute('href')||'';
  if(base.indexOf('/quests/')===-1) return;
  base=base.replace(/[?#].*$/,'');         /* .../quests/ , query stripped */

  U.whenAuthReady(10000).then(function(){
    var A=window.TarrmuAuth;
    if(!A||!A.ready||!A.ghostUuid) return; /* logged out -> keep plain link */

    U.rest('profiles?select=username&ghost_uuid=eq.'+
           encodeURIComponent(A.ghostUuid)+'&limit=1')
      .then(function(rows){
        var u=rows&&rows[0]&&rows[0].username;
        if(u) link.setAttribute('href', base+'?u='+encodeURIComponent(u));
      })
      .catch(function(){ /* leave plain /quests/ on any failure */ });
  });
})();

/* ---------- TARRMU POLLS ----------
   Mounts on every .tarrmu-poll element. Two addressing modes:
     <div class="tarrmu-poll" data-poll-id="<uuid>"></div>    pinned  (articles)
     <div class="tarrmu-poll" data-poll-slot="weekly"></div>  rotating (hub)

   TRACK A: poll_results fires immediately with whatever bearer is cached.
   At parse time that is the anon key, so auth.uid() is null and every is_mine
   comes back false -- tallies still render before auth resolves.
   TRACK B: once auth resolves for a signed-in member we re-call poll_results
   to hydrate is_mine and bind the vote handlers. Logged-out visitors keep the
   read-only render plus a sign-in prompt. Two calls by design, not an
   oversight: Tarrmu.anonRpc is an alias of Tarrmu.rpc, so there is no way to
   get is_mine on the first call without gating the public read on auth.

   XP: cast_poll_vote awards polls.xp_award once per member per poll via the
   poll_xp_awards ledger (permanent -- survives retract) and returns the
   authoritative new total. We write TarrmuAuth.member.xp and fire
   `tarrmu-xp-synced` with the same {xp, completed} detail shape the quest
   sync block uses, so any XP display refreshes without a reload.

   A slot with no currently-active poll returns zero rows -> the mount hides
   itself rather than rendering an empty shell. */
(function(){'use strict';
  var U=window.Tarrmu;
  if(!U||window.__tarrmuPollsBooted) return;
  window.__tarrmuPollsBooted=true;

  var SIGNIN='#/portal/signin';

  function el(tag,cls,txt){
    var n=document.createElement(tag);
    if(cls) n.className=cls;
    if(txt!=null) n.textContent=txt;
    return n;
  }
  function pct(n,total){ return total>0?Math.round(n/total*100):0; }
  function plural(n,word){ return n+' '+word+(n===1?'':'s'); }

  function closesLabel(iso){
    if(!iso) return '';
    var ms=new Date(iso).getTime()-Date.now();
    if(isNaN(ms)) return '';
    if(ms<=0) return 'closed';
    var d=Math.floor(ms/86400000); if(d>=1) return 'closes in '+d+'d';
    var h=Math.floor(ms/3600000);  if(h>=1) return 'closes in '+h+'h';
    return 'closes in '+Math.max(1,Math.floor(ms/60000))+'m';
  }

  function Poll(root,opts){
    opts = opts || {};
    this.root    = root;
    this.pollId  = opts.pollId || root.getAttribute('data-poll-id')  || null;
    this.slot    = opts.slot   || root.getAttribute('data-poll-slot')|| null;
    this.compact = !!opts.compact;   /* hub cell variant */
    this.state   = null;
    this.authed  = false;
    this.busy    = false;
    this.nodes   = null;
  }

  Poll.prototype.args=function(){
    return this.pollId ? {p_poll_id:this.pollId} : {p_slot:this.slot};
  };

  /* rows from poll_results carry the poll header; rows from cast/retract do not */
  Poll.prototype.absorb=function(rows,withHeader){
    if(!Array.isArray(rows)||!rows.length) return false;
    var r0=rows[0];
    if(withHeader){
      this.pollId=r0.poll_id;
      this.state={
        question:r0.question,
        xpAward:Number(r0.xp_award)||0,
        isLive:!!r0.is_live,
        closesAt:r0.closes_at,
        total:0,options:[],mine:null
      };
    }
    if(!this.state) return false;
    this.state.total=Number(r0.total_votes)||0;
    this.state.mine=null;
    var self=this;
    this.state.options=rows.map(function(r){
      var o={id:r.option_id,label:r.label,votes:Number(r.votes)||0,isMine:!!r.is_mine};
      if(o.isMine) self.state.mine=o.id;
      return o;
    });
    return true;
  };

  Poll.prototype.skeleton=function(){
    this.root.textContent='';
    if(this.compact){ this.root.appendChild(el('div','hub-empty','// LOADING…')); return; }
    this.root.appendChild(el('div','tpo-skel'));
  };

  Poll.prototype.fail=function(){
    this.root.textContent='';
    if(this.compact){ this.root.appendChild(el('div','hub-empty','// UNAVAILABLE')); return; }
    var p=el('div','tpo-panel');
    p.appendChild(el('div','tpo-note','POLL UNAVAILABLE'));
    this.root.appendChild(p);
  };

  Poll.prototype.render=function(){
    if(!this.state){ this.root.hidden=true; return; }
    this.root.hidden=false;
    return this.compact ? this.renderCompact() : this.renderFull();
  };

  /* ---- compact variant: homepage hub cell ---- */
  Poll.prototype.renderCompact=function(){
    var s=this.state, self=this;
    this.root.textContent='';

    var wrap=el('div','hubp');
    wrap.appendChild(el('div','hubp-q',s.question));

    var canVote = this.authed && s.isLive && !this.busy;
    wrap.classList.toggle('hubp-can-vote',canVote);

    var opts=el('div','hubp-opts');
    s.options.forEach(function(o){
      var b=document.createElement('button');
      b.type='button';
      b.className='hubp-opt'+(o.isMine?' hubp-mine':'');
      if(!canVote) b.disabled=true;
      b.setAttribute('aria-pressed',o.isMine?'true':'false');

      var fill=el('span','hubp-fill');
      fill.style.width=pct(o.votes,s.total)+'%';
      b.appendChild(fill);

      var line=el('span','hubp-line');
      line.appendChild(el('span','hubp-label',o.label));
      line.appendChild(el('span','hubp-pct',pct(o.votes,s.total)+'%'));
      b.appendChild(line);

      b.addEventListener('click',function(){ self.vote(o.id); });
      opts.appendChild(b);
    });
    wrap.appendChild(opts);

    var foot=el('div','hubp-foot');
    var note=el('span','hubp-note');
    if(!s.isLive)            note.textContent='CLOSED';
    else if(!this.authed)    note.textContent='SIGN IN TO VOTE';
    else if(s.mine)          note.textContent='VOTE RECORDED';
    else                     note.textContent='PICK ONE';
    foot.appendChild(note);

    var right=el('span','hubp-right',plural(s.total,'vote')+(s.xpAward>0?' · +'+s.xpAward+' XP':''));
    foot.appendChild(right);
    wrap.appendChild(foot);

    var xp=el('span','tpo-xp');
    wrap.appendChild(xp);
    wrap.appendChild(el('div','tpo-err'));

    this.root.appendChild(wrap);
    this.nodes={panel:wrap,xp:xp,err:wrap.querySelector('.tpo-err')};
  };

  Poll.prototype.renderFull=function(){
    var s=this.state, self=this;
    this.root.textContent='';

    var panel=el('div','tpo-panel');
    panel.appendChild(el('div','tpo-q',s.question));

    var meta=el('div','tpo-meta');
    if(s.xpAward>0){
      meta.appendChild(el('b','','+'+s.xpAward+' XP'));
      meta.appendChild(el('span','tpo-sep','·'));
    }
    meta.appendChild(el('span','',plural(s.total,'vote')));
    var cl=closesLabel(s.closesAt);
    if(cl){
      meta.appendChild(el('span','tpo-sep','·'));
      meta.appendChild(el('span','',cl));
    }
    panel.appendChild(meta);

    var canVote = this.authed && s.isLive && !this.busy;
    panel.classList.toggle('tpo-can-vote',canVote);

    var opts=el('div','tpo-opts');
    s.options.forEach(function(o){
      var b=document.createElement('button');
      b.type='button';
      b.className='tpo-opt'+(o.isMine?' tpo-mine':'');
      b.setAttribute('data-oid',o.id);
      if(!canVote) b.disabled=true;
      b.setAttribute('aria-pressed',o.isMine?'true':'false');

      var fill=el('span','tpo-fill');
      fill.style.width=pct(o.votes,s.total)+'%';
      b.appendChild(fill);

      var line=el('span','tpo-line');
      line.appendChild(el('span','tpo-label',o.label));
      line.appendChild(el('span','tpo-n',String(o.votes)));
      line.appendChild(el('span','tpo-pct',pct(o.votes,s.total)+'%'));
      b.appendChild(line);

      b.addEventListener('click',function(){ self.vote(o.id); });
      opts.appendChild(b);
    });
    panel.appendChild(opts);

    var foot=el('div','tpo-foot');
    var note=el('span','tpo-note');
    if(!s.isLive){
      note.textContent='VOTING CLOSED';
    } else if(!this.authed){
      note.appendChild(document.createTextNode('SIGN IN TO VOTE'));
      var a=el('a','',' [ SIGN IN ]'); a.href=SIGNIN;
      note.appendChild(a);
    } else if(s.mine){
      note.textContent='VOTE RECORDED';
    } else {
      note.textContent='PICK ONE';
    }
    foot.appendChild(note);

    var xp=el('span','tpo-xp');
    foot.appendChild(xp);

    var rt=document.createElement('button');
    rt.type='button'; rt.className='tpo-retract'; rt.textContent='[ RETRACT ]';
    rt.hidden=!(this.authed&&s.isLive&&s.mine);
    rt.addEventListener('click',function(){ self.retract(); });
    foot.appendChild(rt);

    panel.appendChild(foot);
    panel.appendChild(el('div','tpo-err'));
    this.root.appendChild(panel);
    this.nodes={panel:panel,xp:xp,err:panel.querySelector('.tpo-err')};
  };

  Poll.prototype.err=function(msg){
    if(this.nodes&&this.nodes.err) this.nodes.err.textContent=msg||'';
  };

  Poll.prototype.flashXp=function(n){
    if(!n||!this.nodes||!this.nodes.xp) return;
    var x=this.nodes.xp;
    x.textContent='+'+n+' XP';
    x.classList.add('tpo-show');
    setTimeout(function(){ x.classList.remove('tpo-show'); },4000);
  };

  Poll.prototype.broadcastXp=function(newXp){
    if(newXp==null) return;
    try{
      var A=window.TarrmuAuth;
      if(A&&A.member) A.member.xp=Number(newXp);
    }catch(e){}
    window.dispatchEvent(new CustomEvent('tarrmu-xp-synced',{
      detail:{ xp:Number(newXp), completed:[] }
    }));
  };

  Poll.prototype.vote=function(optionId){
    if(this.busy||!this.authed||!this.state||!this.state.isLive) return;
    if(this.state.mine===optionId) return;   /* same option -> no-op */
    var self=this;
    this.busy=true; this.err('');
    U.rpc('cast_poll_vote',{p_option_id:optionId})
      .then(function(rows){
        self.busy=false;
        if(!self.absorb(rows,false)){ self.err('Vote failed.'); return; }
        var award=Number(rows[0].xp_awarded)||0;
        var newXp=rows[0].new_xp;
        self.render();
        if(award>0){ self.flashXp(award); self.broadcastXp(newXp); }
      })
      .catch(function(e){
        self.busy=false;
        self.err(/closed/i.test(String(e&&e.message))?'This poll has closed.':'Vote failed. Try again.');
      });
  };

  Poll.prototype.retract=function(){
    if(this.busy||!this.authed||!this.pollId) return;
    var self=this;
    this.busy=true; this.err('');
    U.rpc('retract_poll_vote',{p_poll_id:this.pollId})
      .then(function(rows){
        self.busy=false;
        if(self.absorb(rows,false)) self.render();
      })
      .catch(function(){ self.busy=false; self.err('Could not retract. Try again.'); });
  };

  /* TRACK A -- public read, fires immediately */
  Poll.prototype.load=function(){
    var self=this;
    if(!this.pollId&&!this.slot){ this.root.hidden=true; return; }
    this.skeleton();
    U.rpc('poll_results',this.args())
      .then(function(rows){
        if(!self.absorb(rows,true)){ self.root.hidden=true; return; }
        self.render();
        self.hydrate();
      })
      .catch(function(){ self.fail(); });
  };

  /* TRACK B -- re-read as the member so is_mine is populated, then bind */
  Poll.prototype.hydrate=function(){
    var self=this;
    U.whenAuthReady(10000).then(function(){
      var A=window.TarrmuAuth;
      if(!A||!A.ready||!A.ghostUuid) return;   /* logged out: read-only render stands */
      self.authed=true;
      U.rpc('poll_results',self.args())
        .then(function(rows){ if(self.absorb(rows,true)) self.render(); })
        .catch(function(){ self.render(); });  /* still enable voting on a failed re-read */
    });
  };

  /* exported so the homepage hub module can reuse the vote/XP logic
     instead of duplicating it against the same three RPCs */
  U.Poll=Poll;

  U.onReady(function(){
    var all=document.querySelectorAll('.tarrmu-poll');
    if(!all.length) return;
    /* a hand-placed mount wins over the template auto-mount on the same page */
    var manual=[], auto=[];
    Array.prototype.forEach.call(all,function(m){
      (m.hasAttribute('data-poll-auto')?auto:manual).push(m);
    });
    if(manual.length){
      auto.forEach(function(m){ m.hidden=true; });
      manual.forEach(function(m){ new Poll(m).load(); });
    } else {
      auto.forEach(function(m){ new Poll(m).load(); });
    }
  });
})();

/* ---------- TARRMU HUB POLL (homepage Community Hub, 4th module) ----------
   Fills #hubPoll rendered by partials/tarrmu/hub.hbs. Desktop-only, matching
   the other three hub widgets: bails under 1280px so mobile pays nothing.

   Weekly and monthly share one cell via tabs rather than taking two cells --
   at ~485px per cell in the 2x2 grid, two poll cells would eat half the hub.
   The chosen tab persists in localStorage so it survives navigation.

   Reuses Tarrmu.Poll in compact mode, so voting, the XP ledger call and the
   `tarrmu-xp-synced` broadcast are the exact same code path as the full
   article widget -- nothing about the award logic is duplicated here.

   NOTE: mobile members cannot reach this module at all. The same two slots
   must also be mounted on the Community Hub page (full-width, not gated) or
   mobile members are locked out of the site's only recurring XP source. */
(function(){'use strict';
  var widget=document.getElementById('hubPoll');
  if(!widget) return;
  if(!window.matchMedia||!window.matchMedia('(min-width:1280px)').matches) return;

  var U=window.Tarrmu;
  if(!U||typeof U.Poll!=='function') return;

  var KEY='tarrmu_hub_poll_tab';
  var body=widget.querySelector('.hubw-body');
  var tabs=widget.querySelectorAll('.hubp-tab');
  if(!body||!tabs.length) return;

  function remember(slot){ try{ localStorage.setItem(KEY,slot); }catch(e){} }
  function recall(){
    try{ return localStorage.getItem(KEY)||'weekly'; }catch(e){ return 'weekly'; }
  }

  function show(slot){
    Array.prototype.forEach.call(tabs,function(t){
      var on=t.getAttribute('data-slot')===slot;
      t.classList.toggle('is-on',on);
      t.setAttribute('aria-selected',on?'true':'false');
    });
    body.textContent='';
    var mount=document.createElement('div');
    mount.className='hubp-mount';
    body.appendChild(mount);
    new U.Poll(mount,{slot:slot,compact:true}).load();
  }

  Array.prototype.forEach.call(tabs,function(t){
    t.addEventListener('click',function(){
      var slot=t.getAttribute('data-slot');
      remember(slot);
      show(slot);
    });
  });

  show(recall());
})();

/* ============================================================
   LOCALE — country/currency detection + preference (2026-08-23)
   Detects country from the browser (IANA tz -> ISO 3166-1,
   fallback: navigator.language region), maps country -> default
   currency, and persists the pair to localStorage 'tr_locale'.
   Exposed as window.Tarrmu.LOCALE so the settings page, profile
   page and game page all share one source of truth.
   ============================================================ */
(function(){
  var TZ2CC = {
    'Australia/Sydney':'AU','Australia/Melbourne':'AU','Australia/Brisbane':'AU',
    'Australia/Adelaide':'AU','Australia/Perth':'AU','Australia/Hobart':'AU',
    'America/New_York':'US','America/Chicago':'US','America/Denver':'US',
    'America/Los_Angeles':'US','America/Phoenix':'US','America/Anchorage':'US',
    'America/Indiana/Indianapolis':'US','America/Detroit':'US','America/Boise':'US',
    'Pacific/Honolulu':'US','America/Toronto':'CA','America/Vancouver':'CA',
    'America/Montreal':'CA','America/Calgary':'CA','America/Edmonton':'CA',
    'America/Winnipeg':'CA','America/Halifax':'CA','America/St_Johns':'CA',
    'Europe/London':'GB','Europe/Dublin':'IE','Europe/Paris':'FR',
    'Europe/Berlin':'DE','Europe/Madrid':'ES','Europe/Rome':'IT',
    'Europe/Amsterdam':'NL','Europe/Brussels':'BE','Europe/Vienna':'AT',
    'Europe/Zurich':'CH','Europe/Stockholm':'SE','Europe/Oslo':'NO',
    'Europe/Copenhagen':'DK','Europe/Helsinki':'FI','Europe/Lisbon':'PT',
    'Europe/Athens':'GR','Europe/Warsaw':'PL','Europe/Prague':'CZ',
    'Europe/Budapest':'HU','Europe/Bucharest':'RO','Europe/Kyiv':'UA',
    'Europe/Moscow':'RU','Europe/Istanbul':'TR','Europe/Dublin':'IE',
    'Asia/Tokyo':'JP','Asia/Seoul':'KR','Asia/Shanghai':'CN',
    'Asia/Hong_Kong':'HK','Asia/Taipei':'TW','Asia/Singapore':'SG',
    'Asia/Kuala_Lumpur':'MY','Asia/Bangkok':'TH','Asia/Jakarta':'ID',
    'Asia/Manila':'PH','Asia/Ho_Chi_Minh':'VN','Asia/Kolkata':'IN',
    'Asia/Dubai':'AE','Asia/Riyadh':'SA','Asia/Jerusalem':'IL',
    'Asia/Tehran':'IR','Pacific/Auckland':'NZ','Pacific/Chatham':'NZ',
    'America/Mexico_City':'MX','America/Sao_Paulo':'BR','America/Argentina/Buenos_Aires':'AR',
    'America/Santiago':'CL','America/Bogota':'CO','America/Lima':'PE',
    'America/Caracas':'VE','Africa/Cairo':'EG','Africa/Johannesburg':'ZA',
    'Africa/Lagos':'NG','Africa/Nairobi':'KE'
  };
  /* ISO 3166-1 alpha-2 -> [name, default currency ISO 4217] */
  var CC = {
    'AU':['Australia','AUD'],'US':['United States','USD'],'GB':['United Kingdom','GBP'],
    'CA':['Canada','CAD'],'NZ':['New Zealand','NZD'],'JP':['Japan','JPY'],
    'DE':['Germany','EUR'],'FR':['France','EUR'],'IT':['Italy','EUR'],
    'ES':['Spain','EUR'],'NL':['Netherlands','EUR'],'BE':['Belgium','EUR'],
    'AT':['Austria','EUR'],'IE':['Ireland','EUR'],'PT':['Portugal','EUR'],
    'GR':['Greece','EUR'],'FI':['Finland','EUR'],'SE':['Sweden','SEK'],
    'NO':['Norway','NOK'],'DK':['Denmark','DKK'],'CH':['Switzerland','CHF'],
    'PL':['Poland','PLN'],'CZ':['Czechia','CZK'],'HU':['Hungary','HUF'],
    'RO':['Romania','RON'],'UA':['Ukraine','UAH'],'RU':['Russia','RUB'],
    'TR':['Turkey','TRY'],'MX':['Mexico','MXN'],'BR':['Brazil','BRL'],
    'AR':['Argentina','ARS'],'CL':['Chile','CLP'],'CO':['Colombia','COP'],
    'PE':['Peru','PEN'],'VE':['Venezuela','VES'],'EG':['Egypt','EGP'],
    'ZA':['South Africa','ZAR'],'NG':['Nigeria','NGN'],'KE':['Kenya','KES'],
    'IN':['India','INR'],'CN':['China','CNY'],'KR':['South Korea','KRW'],
    'HK':['Hong Kong','HKD'],'TW':['Taiwan','TWD'],'SG':['Singapore','SGD'],
    'MY':['Malaysia','MYR'],'TH':['Thailand','THB'],'ID':['Indonesia','IDR'],
    'PH':['Philippines','PHP'],'VN':['Vietnam','VND'],'AE':['United Arab Emirates','AED'],
    'SA':['Saudi Arabia','SAR'],'IL':['Israel','ILS'],'IR':['Iran','IRR']
  };
  var KEY = 'tr_locale';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY)||'null') || {}; } catch(e){ return {}; } }
  function write(o){ try { localStorage.setItem(KEY, JSON.stringify(o)); } catch(e){} }
  function detectCountry(){
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && TZ2CC[tz]) return TZ2CC[tz];
    } catch(e){}
    try {
      var m = (navigator.language || '').match(/[-_]([A-Za-z]{2})$/);
      if (m && CC[m[1].toUpperCase()]) return m[1].toUpperCase();
    } catch(e){}
    return '';
  }
  function ensure(){
    var o = read();
    if (!o.country) {
      o.country = detectCountry();
      o.currency = (CC[o.country]||[])[1] || 'AUD';
      write(o);
    }
    return o;
  }
  window.Tarrmu.LOCALE = {
    info: CC,
    tz2cc: TZ2CC,
    get: function(){ return ensure(); },
    set: function(country, currency){
      var o = { country: country || '', currency: currency || ((CC[country]||[])[1] || 'AUD') };
      write(o); return o;
    },
    name: function(cc){ return (CC[cc]||[])[0] || cc || ''; },
    flag: function(cc){ return cc ? 'https://flagcdn.com/w20/' + cc.toLowerCase() + '.png' : ''; },
    currencyName: function(cur){
      var names = { 'AUD':'Australian Dollar','USD':'US Dollar','GBP':'British Pound','EUR':'Euro','CAD':'Canadian Dollar','NZD':'New Zealand Dollar','JPY':'Japanese Yen','SEK':'Swedish Krona','NOK':'Norwegian Krone','DKK':'Danish Krone','CHF':'Swiss Franc','PLN':'Polish Zloty','CZK':'Czech Koruna','HUF':'Hungarian Forint','RON':'Romanian Leu','UAH':'Ukrainian Hryvnia','RUB':'Russian Ruble','TRY':'Turkish Lira','MXN':'Mexican Peso','BRL':'Brazilian Real','ARS':'Argentine Peso','CLP':'Chilean Peso','COP':'Colombian Peso','PEN':'Peruvian Sol','VES':'Venezuelan Bolivar','EGP':'Egyptian Pound','ZAR':'South African Rand','NGN':'Nigerian Naira','KES':'Kenyan Shilling','INR':'Indian Rupee','CNY':'Chinese Yuan','KRW':'South Korean Won','HKD':'Hong Kong Dollar','TWD':'New Taiwan Dollar','SGD':'Singapore Dollar','MYR':'Malaysian Ringgit','THB':'Thai Baht','IDR':'Indonesian Rupiah','PHP':'Philippine Peso','VND':'Vietnamese Dong','AED':'UAE Dirham','SAR':'Saudi Riyal','ILS':'Israeli Shekel','IRR':'Iranian Rial' };
      return names[cur] || cur || '';
    }
  };

  /* 4_1_301: one money formatter for the whole site. Symbol + decimals per
     currency (no-cent currencies like JPY/KRW/IDR/VND show whole units).
     approx=true prefixes "≈" (converted from another currency, not the store's own price). */
  var SYM = { AUD:'A$', USD:'US$', GBP:'\u00a3', EUR:'\u20ac', CAD:'C$', NZD:'NZ$', JPY:'\u00a5', CNY:'CN\u00a5',
    KRW:'\u20a9', INR:'\u20b9', HKD:'HK$', TWD:'NT$', SGD:'S$', MYR:'RM', THB:'\u0e3f', IDR:'Rp', PHP:'\u20b1',
    VND:'\u20ab', UAH:'\u20b4', RUB:'\u20bd', TRY:'\u20ba', ILS:'\u20aa', BRL:'R$', MXN:'MX$', ARS:'AR$', CLP:'CLP$',
    COP:'COL$', PEN:'S/', ZAR:'R', CHF:'CHF ', SEK:'kr ', NOK:'kr ', DKK:'kr ', PLN:'z\u0142 ', CZK:'K\u010d ',
    HUF:'Ft ', RON:'lei ', AED:'AED ', SAR:'SAR ', EGP:'E\u00a3', NGN:'\u20a6', KES:'KSh ', ISK:'kr ', VES:'Bs ', IRR:'IRR ' };
  var NODEC = { JPY:1, KRW:1, IDR:1, VND:1, CLP:1, COP:1, HUF:1, ISK:1, TWD:1, IRR:1 };
  window.Tarrmu.money = function(v, cur, approx){
    if (v == null || v === '' || isNaN(v)) return '\u2014';
    var c = String(cur || 'AUD').toUpperCase(), n = Number(v);
    var d = NODEC[c] ? 0 : 2;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
    return (approx ? '\u2248' : '') + (SYM[c] || (c + ' ')) + s;
  };
  /* the member's display currency: saved profile currency (synced below) >
     browser-detected > AUD */
  window.Tarrmu.currency = function(){
    try { var o = JSON.parse(localStorage.getItem('tr_locale') || 'null'); if (o && o.currency) return String(o.currency).toUpperCase(); } catch(e){}
    return 'AUD';
  };
  (function syncSaved(){
    function go(){
      var U2 = window.Tarrmu; if (!U2 || !U2.rpc || !(window.TarrmuAuth && window.TarrmuAuth.ghostUuid)) return;
      U2.rpc('get_my_locale', {}).then(function(l){
        if (!l || !l.currency) return;
        var o = read();
        if (o.currency !== l.currency || (l.country && o.country !== l.country)) {
          o.currency = l.currency; if (l.country) o.country = l.country; write(o);
          try { window.dispatchEvent(new CustomEvent('tarrmu-currency', { detail: { currency: l.currency } })); } catch(e){}
        }
      }).catch(function(){});
    }
    window.addEventListener('tarrmu-auth-ready', go);
    if (window.TarrmuAuth && window.TarrmuAuth.ghostUuid) setTimeout(go, 0);
  })();
})();
